/** UI copy: Brazilian Portuguese (você). Prefer "baralho". */
export const pt = {
  maintenance: {
    title: 'Manutenção',
    body: 'Estamos preparando a próxima expansão. O site volta sozinho quando terminar.',
  },
  card: {
    attr: {
      DARK: 'TREVAS',
      LIGHT: 'LUZ',
      FIRE: 'FOGO',
      WATER: 'ÁGUA',
      EARTH: 'TERRA',
      WIND: 'VENTO',
    },
    race: {
      Aqua: 'Aqua',
      Beast: 'Besta',
      'Beast-Warrior': 'Besta-Guerreira',
      Continuous: 'Contínuo',
      Dinosaur: 'Dinossauro',
      Dragon: 'Dragão',
      Equip: 'Equipamento',
      Fairy: 'Anjo',
      Field: 'Campo',
      Fiend: 'Demônio',
      Fish: 'Peixe',
      Insect: 'Inseto',
      Machine: 'Máquina',
      Normal: 'Normal',
      Plant: 'Planta',
      Pyro: 'Piro',
      Reptile: 'Réptil',
      Rock: 'Rocha',
      'Sea Serpent': 'Serpente Marinha',
      Spellcaster: 'Mago',
      Thunder: 'Trovão',
      Warrior: 'Guerreiro',
      'Winged Beast': 'Besta Alada',
      Zombie: 'Zumbi',
    },
    type: {
      'Normal Monster': 'Monstro Normal',
      'Effect Monster': 'Monstro de Efeito',
      'Flip Effect Monster': 'Monstro de Efeito de Virar',
      'Fusion Monster': 'Monstro de Fusão',
      'Spell Card': 'Card de Magia',
      'Trap Card': 'Card de Armadilha',
    },
    stType: {
      'Normal Spell': 'Magia Normal',
      'Equip Spell': 'Magia de Equipamento',
      'Field Spell': 'Magia de Campo',
      'Continuous Spell': 'Magia Contínua',
      'Normal Trap': 'Armadilha Normal',
      'Continuous Trap': 'Armadilha Contínua',
    },
    token: {
      Normal: 'Normal',
      Effect: 'Efeito',
      Fusion: 'Fusão',
      Flip: 'Virar',
    },
  },
  mobile: {
    rotateTitle: 'Vire o celular',
    rotateHint: 'Os duelos são em paisagem.',
    close: 'Fechar',
    closeMenu: 'Fechar menu',
    menu: 'Menu',
    filters: 'Filtros',
  },
  nav: {
    brand: 'Dueling Chaos',
    home: 'Início',
    packs: 'Pacotes',
    deckBuilder: 'Construtor de baralho',
    collection: 'Coleção',
    duel: 'Duelo',
    duelPick: 'Como você quer jogar?',
    duelVsAi: 'Duelo contra a IA',
    duelVsAiHint: 'Seu baralho contra a CPU.',
    duelRanked: 'Ranqueado online',
    duelRankedHint: 'Partida rápida contra outro duelista.',
    duelCasual: 'Fila casual',
    duelCasualHint: 'Sua liga não muda.',
    duelEventHint: 'Uma fila semanal. Uma vitória paga um Master Pack. Sua liga não muda.',
    queueWaiting: '{n} na fila',
    queueClosed: 'Ranqueado em pausa',
    rankedOfferHint: '{n} moedas só por jogar',
    duelCancel: 'Cancelar',
    missions: 'Missões',
    news: 'Novidades',
    banlist: 'Banlist',
    popular: 'Populares',
    tournaments: 'Torneios',
    faq: 'FAQ',
    mailbox: 'Correio',
    language: 'Idioma',
    account: 'Conta',
    settings: 'Ajustes',
    profile: 'Perfil',
    friends: 'Amigos',
    admin: 'Admin',
    rank: 'Ranqueado',
    menu: 'Menu da conta',
    loading: 'Carregando',
    fullscreen: 'Tela cheia',
    fullscreenExit: 'Sair da tela cheia',
  },
  splash: {
    skip: 'Pular',
  },
  coins: {
    balance: 'Moedas',
  },
  interrupt: {
    toast: 'O duelo foi interrompido por uma atualização. Você ganhou {n} moedas.',
  },
  bugReward: {
    toast: 'O bug que você reportou era real. Você ganhou 1 moeda e 1 Master Pack.',
    toastMany: 'Os bugs que você reportou eram reais. Você ganhou {n} moedas e {n} Master Packs.',
  },
  staffGrant: {
    toastCoin: 'Você ganhou 1 moeda.',
    toastCoins: 'Você ganhou {n} moedas.',
    toastPack: 'Você ganhou 1 Master Pack.',
    toastPacks: 'Você ganhou {n} Master Packs.',
    toastBoth: 'Você ganhou {coins} moedas e {packs} Master Packs.',
  },
  mailbox: {
    kicker: 'Conta',
    title: 'Correio',
    lead: 'Novidades para ver e mensagens da equipe.',
    back: 'Início',
    news: 'Novidades',
    messages: 'Mensagens',
    reviewNews: 'Ver',
    team: 'Equipe',
    dialogTitle: 'Mensagem',
    claim: 'Resgatar',
    claiming: 'Resgatando…',
    claimed: 'Resgatado',
    gotIt: 'Entendi',
    close: 'Fechar',
    coin: '1 moeda',
    coins: '{n} moedas',
    pack: '1 Master Pack',
    packs: '{n} Master Packs',
    rewardBoth: '{coins} e {packs}',
    claimError: 'Não foi possível resgatar esta recompensa.',
    empty: 'Não há mensagens.',
    loading: 'Carregando…',
    loadError: 'Não foi possível carregar o correio.',
    pendingBadge: '{n} não lidas',
    clearSettled: 'Limpar lidas e resgatadas',
    clearing: 'Limpando…',
    clearError: 'Não foi possível limpar o correio.',
    seasonCpu:
      'Você ficou em #{position} na escada de {difficulty} contra a CPU nesta temporada. Aqui está 1 Master Pack.',
    playtimeMrd:
      'Você é o #{position} por horas jogadas. Aqui está um pacote especial de Metal Raiders: 5 cartas Ultra Rare ou mais.',
    playtimePack: '1 pacote especial de Metal Raiders',
    tournament: {
      champion: 'Você ganhou o torneio eliminatório. Aqui estão {coins} moedas e um Master Pack.',
      finalist: 'Você chegou à final. Aqui estão {coins} moedas e um Master Pack.',
      semi: 'Você chegou à semifinal. Aqui estão {coins} moedas e um Master Pack.',
      quarters: 'Você chegou às quartas. Aqui estão {coins} moedas e um Master Pack.',
      eighths: 'Você chegou às oitavas. Aqui estão {coins} moedas e um Master Pack.',
      play: 'Você jogou o torneio eliminatório. Aqui está um Master Pack.',
    },
    eventQueue:
      'Você ficou #{position} na fila de {mode}. Aqui está o seu prêmio.',
  },
  eventQueue: {
    kicker: 'Esta semana',
    lead: 'Vitórias da fila de evento rotativa. Um duelo terminado paga 7 moedas na vitória e 5 na derrota ou empate, igual ao ranqueado. Quando a semana fecha, a porcentagem conta quem ganhou pelo menos um duelo. Você recebe uma faixa só de Master Packs: 20 o top 1%, 15 o resto do top 10%, 8 o resto do top 25%, 4 o resto do top 50% e 2 o resto. Um empate em vitórias e derrotas no corte recebe a faixa de cima.',
    board: 'Esta semana',
    boardEmpty: 'Ainda não há vitórias.',
    empty: 'Nenhum evento está rolando.',
    loading: 'Carregando…',
    liveUntil: 'Termina {time}',
    endsIn: 'Termina em {time}',
    closed: 'Este evento já fechou.',
    modes: {
      random_deck: 'Baralho aleatório',
      unlimited: 'Unlimited',
      one_copy: '60 · uma cópia',
    },
    modeHints: {
      random_deck: 'Uma lista Standard nova em cada duelo. Você não leva baralho.',
      unlimited: 'Suas cartas. Três cópias, sem banlist da casa.',
      one_copy: 'Suas cartas. Sessenta no Main, uma de cada nome.',
    },
  },
  tournament: {
    kicker: 'Mata-mata',
    title: 'Torneios',
    history: 'Histórico de torneios',
    historyLead: 'Os últimos 10 torneios encerrados. Abra um para ver a chave e os baralhos.',
    empty: 'Ainda não há torneios encerrados.',
    upcoming: 'A inscrição abre às {time}',
    countdown: 'Começa em {time}',
    waitHours: 'Faltam {n} horas para o próximo torneio.',
    waitHour: 'Falta 1 hora para o próximo torneio.',
    waitMinutes: 'Faltam {n} minutos para o próximo torneio.',
    waitMinute: 'Falta 1 minuto para o próximo torneio.',
    waitSoon: 'O próximo torneio está para começar.',
    waitJoin: 'Inscreva-se e jogue pelas recompensas.',
    joinWindow: 'Você poderá se inscrever nos últimos 30 minutos. O botão aparece aqui.',
    registration: 'Inscrição aberta',
    openTitle: 'A inscrição está aberta',
    openBody: 'Você já pode se inscrever no próximo torneio. Faltam cerca de {minutes} minutos. Inscreva-se e jogue pelas recompensas.',
    notice2hTitle: 'Faltam 2 horas',
    notice2hBody: 'O próximo torneio começa em 2 horas.',
    notice1hTitle: 'Falta 1 hora',
    notice1hBody: 'O próximo torneio começa em 1 hora.',
    notice5mTitle: 'Faltam 5 minutos',
    notice5mBody: 'O torneio começa em 5 minutos. Inscreva-se se ainda não fez isso.',
    notice1mTitle: 'Falta 1 minuto',
    notice1mBody: 'O torneio começa em 1 minuto.',
    openBracket: 'Ver chave',
    sampleBadge: 'Teste',
    registered: '{n} de {max} inscritos',
    join: 'Inscrever-me',
    leave: 'Sair da inscrição',
    joined: 'Você está inscrito. Esse baralho fica bloqueado até o torneio terminar.',
    pickTitle: 'Escolha seu baralho',
    pickBody:
      'Este baralho fica bloqueado até o torneio terminar. Você ainda pode usá-lo em outros duelos. Sair da inscrição desbloqueia.',
    pickConfirm: 'Inscrever-me com este baralho',
    closedSoon: 'A inscrição fechou. Faltam menos de 30 segundos.',
    autoJoined: 'Você entrou com “{name}”, o baralho que usa nos duelos.',
    live: 'Torneio em andamento',
    sample: 'Chave de teste. Não é um torneio real.',
    spectate: 'Assistir',
    replay: 'Ver replay',
    play: 'Jogar minha partida',
    rejoin: 'Voltar ao meu duelo',
    bye: 'Folga',
    legend: 'Guia',
    markPlay: 'Venceu o duelo',
    markShow: 'Venceu nos 5 minutos',
    markTime: 'Venceu por tempo',
    markNoShow: 'Não entrou na sala',
    markBye: 'Folga',
    versus: '{a} contra {b}',
    advanced: '{name} passou',
    eighths: 'Oitavas',
    quarters: 'Quartas',
    semi: 'Semifinal',
    final: 'Final',
    champion: 'Campeão',
    podiumTitle: 'Salão dos campeões',
    podiumLead: 'Os três duelistas com mais torneios ganhos.',
    podiumWins: '{n} títulos',
    podiumWin: '1 título',
    podiumAria: 'Colocação {place}: {name}, {wins}',
    players: '{n} duelistas',
    duration: 'Tempo total {time}',
    decks: 'Baralhos',
    main: 'Principal',
    extra: 'Extra',
    waiting: 'Esperando a próxima rodada',
    autosPaused: 'Os torneios automáticos estão em pausa.',
    roundClock: 'Rodada {time}',
    yourMatch: 'Sua partida está pronta',
    callBody: '{name} é seu rival. Você tem {minutes} minutos para abrir o duelo.',
    callLater: 'Agora não',
    pushPrompt:
      'Confirme a permissão na barra de endereço. Se não aparecer, ative no cadeado.',
    pushDeniedBrowser:
      'Os avisos estão bloqueados. Ative-os no cadeado da barra de endereço.',
    errors: {
      closed: 'Os torneios estão pausados.',
      full: 'As vagas acabaram.',
      busy: 'Você já está em um duelo ou em uma fila.',
      deck: 'Esse baralho não pode ser usado.',
      banlist: 'Esse baralho não segue a lista.',
      unowned: 'Esse baralho usa cartas que você não tem.',
      not_open: 'A inscrição não está aberta.',
      closed_soon: 'A inscrição fechou faltando 30 segundos.',
    },
  },
  seasonReward: {
    final: 'A temporada acabou. Você ficou em {league} e recebeu {n} pacotes.',
    start: 'Começou uma nova temporada. Você ganhou um pacote de Metal Raiders.',
  },
  level: {
    title: 'Nível da conta',
    lead:
      'Duelar para ganhar XP. Sua liga ranqueada é separada e não muda isso.',
    chip: 'Nv {n}',
    bar: '{into} / {need} XP',
    max: 'Nível máximo',
    kicker: 'Servidor',
    loading: 'Carregando níveis…',
    board: 'Maiores níveis',
    boardEmpty: 'Duelar para ganhar XP e aparecer aqui.',
    place: 'Lugar {n} no servidor',
    viewLadder: 'Ver a escada de níveis',
    nextCoins: 'Próximo: {n} moedas',
    nextPack: 'Próximo: 1 pacote',
    nextBoth: 'Próximo: 1 pacote e {n} moedas',
    xpGain: '+{n} XP',
    xpProgress: 'Progresso do nível',
    levelUp: 'Nível {n}',
    grantCoins: '+{n} moedas',
    grantPack: '1 pacote',
    grantBoth: '1 pacote e {n} moedas',
  },
  aiWins: {
    kicker: 'Contra a IA',
    lead:
      'Cada dificuldade da CPU a partir de Difícil tem a própria escada. Fácil e Normal não entram. Só contam as vitórias terminadas desta temporada.',
    rewardTitle: 'Prêmio da escada contra a CPU',
    rewardPlace: 'Lugar',
    rewardRange: '1 a {n}',
    rewardNote:
      'Enviado ao correio quando a temporada termina, pelas vitórias contra a CPU. Quem empata o {n}º lugar também entra. Difícil, Especialista e Mestre pagam à parte.',
    loading: 'Carregando vitórias…',
    board: 'Vitórias',
    empty: 'Vença um duelo contra a IA em {name} para aparecer aqui.',
    one: '1 vitória',
    many: '{n} vitórias',
    place: 'Lugar {n} no servidor',
  },
  auth: {
    loginTitle: 'Entrar',
    loginLead: 'Use seu e-mail ou nome de usuário. Você precisa de uma conta para usar o Dueling Chaos.',
    registerTitle: 'Criar conta',
    registerLead:
      'Um endereço Gmail, Outlook ou Hotmail, um nome público e uma senha. ' +
      'O e-mail é como você entra e como você redefine a senha se perdê-la.',
    identifier: 'E-mail ou nome de usuário',
    loginPlaceholder: 'voce@email.com ou nome',
    email: 'E-mail',
    username: 'Nome de usuário',
    password: 'Senha',
    passwordHint: 'Pelo menos 4 caracteres',
    showPassword: 'Mostrar senha',
    hidePassword: 'Ocultar senha',
    signIn: 'Entrar',
    createAccount: 'Criar conta',
    noAccount: 'Ainda não tem conta?',
    goRegister: 'Crie uma',
    haveAccount: 'Já tem uma conta?',
    goLogin: 'Entrar',
    forgotLink: 'Esqueceu sua senha?',
    forgotTitle: 'Redefinir senha',
    forgotLead:
      'Digite o e-mail da sua conta. Se coincidir, enviamos um link que funciona por 30 minutos.',
    forgotSend: 'Enviar link',
    forgotSent:
      'Se esse e-mail tem uma conta, enviamos um link. Ele expira em 30 minutos.',
    resetTitle: 'Escolha uma senha nova',
    resetLead:
      'Este link funciona uma única vez. Ao salvar, as outras sessões desta conta são encerradas.',
    resetSave: 'Salvar senha',
    resetMissing: 'Este link não traz um código. Peça um novo.',
    newPassword: 'Senha nova',
    confirmPassword: 'Confirme a senha',
    logout: 'Sair',
    signedIn: 'Entrou como {name}',
    errors: {
      email_domain:
        'Use um endereço Gmail, Outlook ou Hotmail. Guardamos como seu login ' +
        'e para redefinir a senha.',
      email_taken: 'Esse e-mail já está cadastrado.',
      username_taken: 'Esse nome de usuário já está em uso.',
      username_cooldown: 'Você pode mudar seu nome de novo em 30 dias.',
      invalid_credentials: 'E-mail, nome de usuário ou senha incorretos.',
      validation: 'Confira os campos e tente de novo.',
      rate_limited: 'Muitas tentativas. Espere um minuto e tente de novo.',
      database_unavailable:
        'O servidor não alcança o banco agora. Inicie o Postgres local ou use o site ao vivo.',
      network: 'Não foi possível alcançar o servidor.',
      expired: 'Sua sessão acabou. Entre de novo.',
      forgot_limited:
        'Muitos e-mails de redefinição nesta rede. Espere uma hora e tente de novo.',
      reset_invalid: 'Este link é inválido ou expirou. Peça um novo.',
      password_mismatch: 'As senhas não coincidem.',
    },
  },
  chat: {
    show: 'Chat',
    global: {
      title: 'Chat global',
      tab: 'Global',
      placeholder: 'Mensagem...',
      send: 'Enviar',
      show: 'Chat global',
      hide: 'Ocultar chat',
      online: '{n} online',
      expand: 'Ampliar chat',
      medium: 'Tamanho médio',
      full: 'Tela cheia',
      shrink: 'Tamanho normal',
      resize: 'Arraste para mudar o tamanho do chat',
      move: 'Arraste para mover',
      mentionList: 'Duelistas online',
      mentionNone: 'Ninguém mais está online',
      mentionMiss: 'Esse duelista não está online',
      profile: 'Perfil público de {name}',
      latest: 'Ao fim',
      muteOn: 'Você silenciou {name}. As mensagens dessa pessoa não aparecem para você.',
      muteOff: 'Você volta a ver as mensagens de {name}.',
      muteAlready: 'Você já silenciou {name}. Escreva /unmute {name} para ver de novo.',
      unmuteAlready: '{name} não está silenciado.',
      muteSelf: 'Você não pode silenciar a si mesmo.',
      muteMissing: 'Nenhum duelista usa esse nome.',
      muteUsage: 'Escreva /mute e o nome. Para ver de novo, /unmute e o nome.',
      muteFail: 'Não foi possível mudar o silêncio. Tente de novo.',
    },
    duel: {
      tab: 'Duelo',
    },
    dm: {
      close: 'Fechar o chat com {name}',
      placeholder: 'Mensagem para {name}',
      notFriends: '{name} não está na sua lista de amigos.',
      failed: 'Não foi possível enviar a mensagem.',
    },
  },
  friends: {
    kicker: 'Conta',
    title: 'Amigos',
    lead: 'Adicione um duelista pelo nome exato. O chat e os convites de sala são só entre amigos.',
    back: 'Início',
    add: 'Adicionar',
    addLabel: 'Nome',
    loading: 'Carregando amigos…',
    loadError: 'Não foi possível carregar os amigos. Tente de novo.',
    empty: 'Você ainda não tem amigos.',
    incoming: 'Pedidos',
    outgoing: 'Enviados',
    list: 'Amigos',
    accept: 'Aceitar',
    decline: 'Recusar',
    cancel: 'Cancelar',
    remove: 'Remover',
    chat: 'Chat',
    invite: 'Duelo direto',
    sent: 'Pedido enviado para {name}.',
    accepted: 'Você e {name} agora são amigos.',
    acceptedMany: '{n} duelistas aceitaram seu pedido.',
    presence: {
      online: 'Online',
      in_duel: 'Em duelo',
      offline: 'Offline',
    },
    requestIncoming: '{name} enviou um pedido de amizade.',
    pendingBadge: '{n} pedidos de amizade',
    inviteIncoming: '{name} convidou você para uma sala privada.',
    inviteAccept: 'Entrar',
    inviteDecline: 'Agora não',
    inviteDeclined: '{name} recusou a sala.',
    errors: {
      invalid_username: 'Esse nome não é válido.',
      user_not_found: 'Ninguém usa esse nome.',
      cannot_friend_self: 'Esse é o seu próprio nome.',
      already_friends: 'Vocês já são amigos.',
      request_pending: 'Esse pedido já está esperando.',
      friend_cap: 'A lista de amigos está cheia.',
      request_cap: 'Há pedidos demais esperando.',
      not_friends: 'Vocês não são amigos.',
      request_missing: 'Esse pedido já não está.',
      rate_limited: 'Muitas tentativas. Espere um minuto.',
      database_unavailable: 'Amigos não está disponível agora.',
      network: 'Não foi possível alcançar o servidor.',
      friends_failed: 'Não foi possível atualizar. Tente de novo.',
    },
  },
  profile: {
    title: 'Perfil',
    lead: 'O que os outros veem: seu nome, seu retrato, sua liga, seu placar, seu tempo jogado e as cópias que você fixa.',
    account: 'Conta',
    name: 'Nome',
    nameHint:
      'Este nome é o que os outros veem no chat e nos duelos online. As linhas do chat passam a mostrar o nome novo. Você pode mudá-lo uma vez a cada 30 dias.',
    nameCooldown: 'Você pode mudar seu nome de novo em {date}.',
    placeholder: 'Jogador',
    save: 'Salvar',
    saved: 'Salvo',
    tabs: {
      you: 'Você',
      case: 'Vitrine',
      look: 'Visual do duelo',
    },
    public: {
      view: 'Ver sua página pública',
      edit: 'Editar sua vitrine',
      loading: 'Carregando este duelista…',
      missing: 'Nenhum duelista usa esse nome.',
      rateLimited: 'Muitas buscas seguidas. Espere um minuto e abra o perfil de novo.',
      unavailable: 'Não foi possível carregar este perfil. Tente de novo.',
      online: 'Duelos online',
      rankedPlace: 'Ranqueado #{n}',
      levelPlace: 'Top de nível #{n}',
      aiPlace: '{name} #{n}',
      betaPlayer: 'Beta Player',
      betaTitle: 'Terminou a colocação da temporada beta em {league}',
      record: '{wins}–{losses}',
      recordDraws: '{wins}–{losses}–{draws}',
      noDuels: 'Sem duelos',
      historyTitle: 'Duelos',
      historyEmpty: 'Ainda não há duelos.',
      replay: 'Repetir',
      modes: {
        ai: 'contra a CPU',
        pvp_casual: 'Casual contra {name}',
        pvp_ranked: 'Ranqueada contra {name}',
        pvp_event: 'Evento contra {name}',
      },
      results: {
        win: 'Vitória',
        loss: 'Derrota',
        draw: 'Empate',
      },
      mute: 'Silenciar',
      unmute: 'Silenciado',
      muteTitle: 'As mensagens dessa pessoa somem só para você',
      unmuteTitle: 'Toque para ver as mensagens de novo',
      playTime: 'Tempo jogado: {time}',
      playMinutes: '{n} min',
      playHours: '{n} h',
      playHoursMinutes: '{h} h {m} min',
    },
    showcase: {
      title: 'Vitrine de foils',
      lead:
        'Fixe até seis cópias do seu álbum. O primeiro espaço é a peça ' +
        'central. Os outros duelistas veem isso na sua página pública.',
      publicLead: 'Cópias que este duelista escolheu mostrar.',
      emptyOwn: 'Sua vitrine está vazia. Toque um espaço e escolha uma cópia.',
      emptyPublic: 'Este duelista ainda não fixou nenhuma cópia.',
      editHint:
        'Toque um card ou um espaço numerado para trocar essa cópia. Se você tiver várias cópias da mesma carta e raridade, cada uma pode ocupar um espaço.',
      allPinned: 'Todas as cópias desta raridade já estão na vitrine.',
      pick: 'Escolher uma cópia',
      search: 'Buscar no seu álbum',
      needAlbum: 'Abra pacotes para ter cópias para mostrar.',
      clear: 'Limpar este espaço',
      prev: 'Anterior',
      next: 'Próxima',
      page: '{from}–{to} · {page}/{pages}',
    },
    avatar: {
      title: 'Retrato',
      photo: 'Foto do chat',
      random: 'Embaralhar',
      reset: 'Redefinir',
      artTitle: 'Arte',
      framesTitle: 'Moldura',
      frames: {
        gold: 'Ouro',
        silver: 'Prata',
        obsidian: 'Obsidiana',
        ivory: 'Marfim',
        crimson: 'Carmesim',
        azure: 'Azul',
        bronze: 'Bronze',
        emerald: 'Esmeralda',
        'last-call': 'Última chamada',
        'league-duelist': 'Duelista',
        'league-challenger': 'Desafiante',
        'league-champion': 'Campeão',
        'league-king': 'Rei dos Jogos',
      },
      leagueHint:
        'Chegue a uma liga no ranqueado para desbloquear a moldura dela. Ela fica sua para sempre.',
    },
    look: {
      title: 'Visual do duelo',
      lead: 'O tapete e o protetor que você leva para a IA e para os duelos online.',
    },
  },
  rank: {
    title: 'Ranqueado',
    kicker: 'Temporada',
    lead: 'A partida rápida é ranqueada. Salas privadas e duelos contra a IA não mudam sua liga.',
    loading: 'Carregando sua liga…',
    loadError: 'Não foi possível carregar a escada.',
    retry: 'Tentar de novo',
    back: '← Voltar ao início',
    play: 'Jogar ranqueado',
    viewLadder: 'Ver a escada',
    seasonSince: 'A temporada começou em {date}',
    you: 'Você',
    placement: 'Colocação',
    placementLeft: 'Colocação: faltam {n} duelos',
    lpCount: '{lp} / 100 LP',
    lpBare: '{lp} LP',
    lpLine: '{name} · {lp} LP ({delta})',
    lpProgress: 'Pontos da liga',
    promoted: 'Promovido!',
    promoPack: '+1 pacote',
    promoPacks: '+{n} pacotes',
    seasonPacks: '+{n} pacotes no fim',
    rewardsTitle: 'Prêmios de liga',
    rewardsLead:
      'Quando a temporada fecha, quem já terminou a colocação recebe Master Packs da liga em que ficou.',
    rewardsLeague: 'Liga',
    rewardsPrize: 'Prêmio',
    rewardPack: '1 Master Pack',
    rewardPacks: '{n} Master Packs',
    rewardsClimb:
      'Subir de liga dá {league} Master Packs na hora. Subir de divisão dá {division} Master Pack. O protetor, o tapete e a moldura dessa liga ficam com você.',
    cosmeticsUnlocked: 'Novo conjunto da liga {league}',
    cosmeticsWhere: 'Protetor, tapete e moldura. Equipe no seu perfil.',
    demoted: 'Rebaixado',
    board: 'Esta temporada',
    boardEmpty: 'Vença duelos ranqueados para aparecer aqui.',
    prev: 'Anterior',
    next: 'Próxima',
    pager: '{page} / {pages}',
    pagerLabel: 'Páginas da escada',
    prizesLead: 'O que é entregue quando a temporada fecha.',
    tabs: {
      ranked: 'Ranqueado',
      level: 'Nível',
      prizes: 'Prêmios',
      event: 'Evento',
    },
    leagues: {
      duelist: 'Duelista',
      challenger: 'Desafiante',
      champion: 'Campeão',
      king: 'Rei dos Jogos',
    },
  },
  home: {
    title: 'Dueling Chaos',
    kicker: '',
    vsAi: 'Duelo contra a IA',
    vsAiHint: 'Seu baralho contra a CPU.',
    vsAiPick: 'Escolha a dificuldade da CPU',
    vsAiStart: 'Começar duelo',
    vsAiCancel: 'Cancelar',
    vsAiTag: 'Solo',
    playOnline: 'Jogar online',
    onlineHint: 'Partida rápida ranqueada contra outro duelista.',
    casual: 'Fila casual',
    casualTag: 'Sem rank',
    casualHint: 'Sua liga não muda.',
    eventTag: 'Evento',
    eventHint: 'Uma fila semanal. Uma vitória paga 7 moedas; uma derrota ou um empate terminados pagam 5, igual ao ranqueado. No fechamento, Master Packs pela porcentagem de quem ganhou: 20 o top 1%, 15 o resto do top 10%, 8 o resto do top 25%, 4 o resto do top 50% e 2 o resto.',
    eventRankHint: 'A classificação fica em {rank}, em {tab}.',
    queueWaiting: '{n} na fila',
    queueClosed: 'Ranqueado em pausa',
    rankedOffer: 'Jogue uma ranqueada e ganhe {n} moedas.',
    onlineTag: 'PvP',
    rank: 'Melhores jogadores',
    rankTag: 'Escadas',
    rankHint: 'As ligas desta temporada, os níveis da conta e as vitórias contra a IA a partir de Difícil.',
    rooms: 'Salas privadas',
    roomsHint: 'Veja salas abertas ou crie uma. Não é ranqueado.',
    roomsTag: 'Casual',
    watch: 'Assistir duelos',
    watchTag: 'Ao vivo',
    watchHint: 'Assista partidas ranqueadas e salas privadas. As mãos ficam ocultas.',
    packs: 'Pacotes',
    packsHint: 'Abra pacotes e aumente sua coleção.',
    packsTag: 'Boosters',
    missions: 'Missões',
    missionsTag: 'Recompensas',
    missionsHint: 'Tarefas diárias e partidas ranqueadas, por moedas e um pacote da loja.',
    collection: 'Coleção',
    collectionHint: 'O álbum: o que você tem e o que ainda falta.',
    collectionTag: 'Álbum',
    deckBuilder: 'Construtor de baralho',
    deckHint: 'Monte e salve a lista que você leva para a batalha.',
    deckTag: 'Preparar',
    using: 'Seu baralho: {name}',
    playDeck: 'Duelar com',
    deckNotReady: ' (não está pronto)',
    changelog: 'Novidades',
    changelogHint: 'O que mudou no jogo recentemente.',
    banlistHint: 'Máximo 1 ou 2 cópias. A lista muda conforme o meta. Ranqueado, fila casual, salas e contra a CPU.',
    popularHint: 'Quais cartas aparecem mais, com quais viajam, e quantas vezes esses baralhos vencem.',
    faqHint: 'Como se inscrever no torneio, a banlist e os limites diários de recompensa.',
    cardsRestoredTitle: 'Suas cartas',
    cardsRestoredOne:
      'Devolvemos 1 carta que você tinha antes do reset. Ela está na sua coleção, somada às que você conseguiu depois. Não vai ter mais resets. Obrigado por jogar.',
    cardsRestoredMany:
      'Devolvemos {n} cartas que você tinha antes do reset. Elas estão na sua coleção, somadas às que você conseguiu depois. Não vai ter mais resets. Obrigado por jogar.',
    letterKicker: 'Dos desenvolvedores',
    letterTitle: 'Um recado',
    letterThanks:
      'Antes de tudo, quero agradecer a todos pelo apoio e por jogarem tanto.',
    letterTesting:
      'Quero avisar que **Metal Raiders** já está em teste. O avanço das cartas está em cerca de **90%**, mas peço paciência, porque ainda há outras coisas para trabalhar: recompensas, balanceamento do ranqueado e outros sistemas que quero afinados para o lançamento de Metal Raiders.',
    letterRewards:
      'Sei que o jogo está num estado um tanto louco agora, com muitas cópias de cartas fortes, mas saibam que é de propósito. A ideia desta etapa era testar o jogo e corrigir bugs para ter uma boa base antes de seguir com as atualizações. Por isso as recompensas, tanto no ranqueado quanto contra a CPU, estão altíssimas. Assim dá para abrir muitos pacotes e ter muitas cartas em poucas horas de jogo. Isso permitiu que todos pudessem testar todas as cartas e reportar bugs. Obrigado a todos por isso.',
    letterBanlist:
      'Sei que se falou muito de uma banlist, mas a minha ideia é algo diferente: o **RNG**, o grande pool de cartas e recompensas bem mais baixas do que as atuais devem controlar o balanceamento do jogo. Se isso não funcionar, aí vamos ter que começar a pensar numa banlist.',
    letterBreak:
      'Vamos tirar um ou dois dias de descanso e depois o trabalho continua. Espero a compreensão de vocês e, mais uma vez, obrigado.',
    noticeCollect: 'Recolher',
    noticeExpand: 'Expandir',
    keepAllKicker: 'Aviso',
    keepAllTitle: 'Não tem mais reset',
    keepAllLead:
      'Não vai ter mais reset de absolutamente nada. Ficam as **cartas**, as **moedas**, os **pacotes**, tudo.',
    keepAllRank:
      'A única coisa que reinicia é o [[ranking]] de cada [[temporada]].',
    nextSetKicker: 'Próximo set de cartas',
    nextSetTitle: 'Spell Ruler',
    nextSetArtAlt: 'Pacote de Spell Ruler',
    lastCall:
      'Última chamada. Só contam as partidas ranqueadas PVP terminadas. Contra a CPU não conta. {current} de {target}.',
    lastCallOpen: 'Ver os prêmios',
    nextSetLead:
      'Estamos **focados** trabalhando em **Spell Ruler**. Em cerca de **3 semanas** deve estar pronto.',
    nextSetReset:
      'Cada vez que uma nova expansão ou um set de cartas for lançado, [[reiniciamos]] [[as cartas que você obteve]], suas [[moedas]], sua [[liga]] e seu [[nível]]. Sua **coleção não é reiniciada**. O reinício evita que jogadores com mais e melhores cartas fiquem com o topo, dá aos jogadores novos a chance de subir e incentiva a variedade nos baralhos.',
    nextSetRewards:
      'Haverá **recompensas** para todos que **participaram e ajudaram** a melhorar o jogo, e também para **quem mais jogou**. Quem ficou no topo do **ranqueado** e no topo **contra a CPU** recebe recompensas **cosméticas** e **pacotes**.',
    pollTitle: 'Reiniciar a coleção?',
    pollLead: 'Vote se a coleção também deve ser reiniciada quando chegar um set novo.',
    pollYes: 'Sim',
    pollNo: 'Não',
    pollTally: '{yes} sim · {no} não',
    pollSaved: 'Voto salvo. Você pode mudar.',
    pollFolded: 'Você votou {vote}. Toque para mudar.',
    pollRewardTitle: 'Recompensas para o topo',
    pollRewardLead:
      'Escreva as recompensas que você quer para quem ficar no topo depois do reinício. Podem ser cosméticas ou cartas.',
    pollRewardPlaceholder: 'Um playmat, sleeves, uma carta específica…',
    pollRewardSend: 'Enviar sugestão',
    pollRewardThanks: 'Recebemos sua sugestão.',
    pollError: 'Não foi possível salvar. Tente de novo.',
    pollLoadError: 'Não foi possível carregar a enquete.',
    pollRate: 'Espere um momento antes de enviar de novo.',
    banPollTitle: 'Cards proibidos?',
    banPollLead:
      'Hoje a lista só limita cards: você pode jogar 1 cópia. Um card proibido não pode ser jogado, ou seja, 0 cópias no baralho. Você quer isso agora, ou por enquanto só cards limitados?',
    banPollForbidden: 'Quero cards proibidos',
    banPollLimited: 'Por enquanto só limitados',
    banPollResults: 'Votos até agora',
    banPollCount: '{count} · {pct}%',
    banPollTally: '{forbidden} querem proibidos · {limited} só limitados',
    banPollEmpty: 'Ainda não há votos.',
    banPollCommentTitle: 'Comentário adicional',
    banPollCommentLead: 'Se quiser, acrescente algo mais sobre os cards proibidos.',
    banPollCommentPlaceholder: 'Seu comentário…',
    banPollCommentSend: 'Enviar comentário',
    banPollCommentThanks: 'Recebemos seu comentário.',
  },
  discord: {
    join: 'Entrar no Discord',
  },
  support: {
    tip: 'Apoiar',
    title: 'Apoiar',
    lead: 'Estes pacotes somam moedas na sua conta. Um pacote da loja custa 20 moedas.',
    rowCoins: '{n} moedas',
    rowPacks: '{n} pacotes',
    other: 'Doar outro valor',
    otherNote: 'Você escolhe o valor. Essa doação não dá moedas.',
    signIn: 'Entre para receber as moedas',
    close: 'Fechar',
    failed: 'O PayPal não abriu. Tente de novo.',
  },
  thanks: {
    kicker: 'Obrigado',
    title: 'A Pequena Maga Negra manda',
    accent: 'um beijo',
    lead: 'Seu apoio mantém o duelo de pé.',
    coins: 'Somamos {n} moedas na sua conta.',
    coinsLater: 'Se você já pagou, as moedas entram na sua conta.',
    back: 'Voltar ao início',
    artAlt: 'A Pequena Maga Negra piscando e mandando um beijo',
  },
  pwa: {
    title: 'Instalar o app',
    lead: 'Instale o Dueling Chaos neste aparelho. Ele abre em tela cheia, como um app nativo.',
    hint: 'Adiciona um ícone na tela inicial ou na área de trabalho. Os duelos ocupam a tela.',
    install: 'Instalar o Dueling Chaos',
    installed: 'Este aparelho já tem o Dueling Chaos instalado.',
    ios: 'No iPhone ou iPad: toque em Compartilhar e depois em Adicionar à Tela de Início.',
    manual: 'Use o menu do navegador para instalar este site como app.',
  },
  push: {
    title: 'Avisos do torneio',
    body: 'Os mesmos avisos do torneio podem chegar com o Dueling Chaos fechado: 2 horas, 1 hora, quando a inscrição abre, 5 minutos, 1 minuto e quando sua partida estiver pronta.',
    enable: 'Ativar avisos',
    later: 'Agora não',
  },
  changelog: {
    kicker: 'Atualizações',
    title: 'Novidades',
    lead: 'Notas para duelistas. Troque o idioma quando quiser no menu da barra de cima.',
    dialogLead: 'Mudanças dos últimos 3 dias.',
    dismiss: 'Entendi',
    open: 'Ver todas',
    pending: 'Novidades pendentes',
    back: '← Voltar ao início',
  },
  meta: {
    kicker: 'Esta temporada',
    title: 'Cartas mais usadas',
    lead: 'Cartas que os duelistas levam nesta temporada quando um duelo começa. O uso é a parte dos baralhos. Essa barra enche contra a carta mais jogada. As vitórias contam só duelos terminados. O número ao lado é como os últimos 7 dias desta temporada mudaram em relação aos 7 anteriores. Toque uma carta para ver com quais ela viaja.',
    back: '← Voltar ao início',
    modes: 'Modo',
    all: 'Todas',
    ranked: 'Ranqueado',
    top: 'Topo',
    topHint: 'Só Campeão e Rei dos Jogos, no ranqueado.',
    casual: 'Casual',
    ai: 'Contra a CPU',
    sort: 'Ordem',
    sortUsage: 'Mais usadas',
    sortWin: 'Vitórias',
    winFloor: 'As vitórias ordenam cartas com pelo menos {n} duelos terminados.',
    decks: '{n} baralhos',
    usage: '{n}% dos baralhos',
    usageShort: 'Uso',
    win: '{n}% de vitórias',
    winShort: 'Vitórias',
    winEmpty: 'Sem duelos terminados',
    sample: '{n} duelos',
    copies: '{n} cópias por baralho',
    copiesSplit: '1× {a}% · 2× {b}% · 3× {c}%',
    deltaUsage: 'Últimos 7 dias {n} em relação aos 7 anteriores',
    deltaWin: 'Últimos 7 dias {n} em relação aos 7 anteriores',
    with: 'Vai com',
    withClose: 'Fechar',
    withSample: '{n} baralhos levam esta carta.',
    withLead: 'A porcentagem é quantos desses baralhos também levam a outra carta.',
    withShare: '{n}% dos baralhos que levam esta',
    withEmpty: 'Ainda não há cartas que viajem com esta nesta temporada.',
    empty: 'Ainda não há duelos nesta temporada.',
    loadError: 'Não foi possível carregar a lista.',
    retry: 'Tentar de novo',
    loading: 'Carregando',
    place: 'Lugar {n}',
  },
  banlist: {
    kicker: 'Todos os duelos',
    title: 'Banlist',
    lead: 'Limites de cópias no ranqueado, na fila casual, nas salas privadas e contra a CPU. Seu baralho também segue esses limites. A lista é permanente e vai mudando conforme o meta.',
    limited1: 'Limited — máximo 1',
    limited2: 'Semi-Limited — máximo 2',
    max: 'Máximo {n}',
    back: '← Voltar ao início',
  },
  banlistReward: {
    kicker: 'Duelista novo',
    title: 'Escolha uma carta da banlist',
    lead: 'Escolha uma carta. Você tem {n} escolhas abertas.',
    leadOne: 'Escolha uma carta. Esta escolha está aberta.',
    owned: 'Você tem {n}',
    max: 'Máximo {n} no baralho',
    confirm: 'Adicionar {name}?',
    confirmBody: 'Uma cópia Common entra na sua coleção.',
    add: 'Adicionar',
    adding: 'Adicionando…',
    back: 'Voltar',
    later: 'Depois',
    profileChoose: 'Escolher carta da banlist',
    profileLeft: '{n} para escolher',
    profileNext: 'A próxima carta da banlist libera no nível {n}.',
    gameOver: 'Você pode escolher uma carta da banlist.',
    gameOverChoose: 'Escolher carta',
    error: 'Não foi possível adicionar essa carta. Tente de novo.',
    empty: 'A banlist está vazia por enquanto.',
  },
  faq: {
    kicker: 'Ajuda',
    title: 'Perguntas frequentes',
    lead: 'Os torneios automáticos, a banlist e os limites diários de recompensa.',
    back: '← Voltar ao início',
    items: {
      tournamentJoin: {
        q: 'Como me inscrevo no torneio?',
        a: 'A inscrição não fica aberta o dia todo. Ela abre **30 minutos** antes do horário. Nesse momento, o cartão do torneio mostra o botão **Inscrever-me**. Você escolhe o baralho e entra.\n\nEsse cartão está no Início, em Duelo e em Torneios. Antes dos 30 minutos o botão não aparece: o cartão diz quanto falta. Se você tocar no aviso dos **5 minutos** ou do **último minuto**, a inscrição também abre.',
      },
      tournamentWhen: {
        q: 'A que horas são os torneios?',
        a: 'Sai um a cada **3 horas**. O contador do cartão usa o seu relógio. A inscrição abre nos últimos **30 minutos**.\n\nSe você estiver no site quando ela abre, aparece um aviso. O sino do cartão também pode avisar com o site fechado, se você aceitar a permissão. Toque no sino riscado para desligar esses avisos.',
      },
      tournamentField: {
        q: 'Quantas vagas tem e quando começa?',
        a: 'São **8** vagas, mata-mata, um duelo por rodada. Começa assim que elas lotam, ou na hora marcada se não lotarem. Com menos de **4** duelistas, é cancelado e ninguém recebe prêmio.\n\nEsses duelos não movem sua liga.',
      },
      tournamentDeck: {
        q: 'Qual baralho eu uso no torneio?',
        a: 'Na inscrição você escolhe um. Esse baralho não pode ser editado até o torneio terminar ou você sair da inscrição. Reciclar fica fechado enquanto você estiver inscrito. Dá para continuar usando em outros duelos.\n\nA inscrição fecha **30 segundos** antes de começar. Se a lista de baralhos ainda estiver aberta nesse momento, você entra com o baralho que usa nos duelos.',
      },
      tournamentPlay: {
        q: 'O que eu faço quando é a minha partida?',
        a: 'Quando seu duelo fica pronto, chega um aviso. Você tem **5 minutos** para abri-lo. Se você não entrar e o rival entrar, ele passa. Cada rodada dura **40 minutos**.',
      },
      tournamentPrizes: {
        q: 'O que se ganha no torneio?',
        a: 'Os prêmios chegam no correio quando o torneio termina. Quem termina um duelo recebe um Master Pack.\n\nCom **5** ou mais, a chave é de 8: as quartas pagam **10** moedas, a semifinal **30**, o finalista **40** e o campeão **50**. Se começar com **4**, a semifinal paga **20**, o finalista **30** e o campeão **40**. Desistir no primeiro duelo não paga.',
      },
      banlist: {
        q: 'A banlist vale para todos os duelos?',
        a: 'Sim. Vale no ranqueado, na fila casual, nas salas privadas e contra a CPU, inclusive o seu baralho. Os baralhos da CPU também a seguem, inclusive em Mestre.',
      },
      banlistMeta: {
        q: 'A banlist é permanente?',
        a: 'Sim. Ela não é mais temporária. A lista vai mudando conforme o meta.',
      },
      rewardsLadder: {
        q: 'A escada da ranqueada tem um limite diário?',
        a: 'Sim. Em Missões, as primeiras **10** partidas ranqueadas terminadas do dia enchem a escada. As etapas **1** a **9** pagam **3** moedas cada. A etapa **7** também dá um pacote da loja, e a etapa **10** dá dois pacotes e nenhuma moeda. A partir da partida 11, essa escada não anda até a meia-noite UTC. Sair da partida não conta.',
      },
      rewardsMatch: {
        q: 'As moedas de um duelo ranqueado têm limite diário?',
        a: 'Não. Uma vitória paga **7**, e uma derrota ou um empate terminados pagam **5**, todas as vezes. Desistir não paga.',
      },
      rewardsEvent: {
        q: 'O que pagam os duelos da fila de evento?',
        a: 'Uma vitória paga **7** moedas, e uma derrota ou um empate terminados pagam **5**, igual ao ranqueado. Desistir não paga. Esses duelos não movem sua liga. Quando a semana fecha, a porcentagem conta quem ganhou pelo menos um duelo e você recebe uma faixa só: **20** Master Packs o top 1%, **15** o resto do top 10%, **8** o resto do top 25%, **4** o resto do top 50% e **2** o resto. Um empate em vitórias e derrotas no corte recebe a faixa de cima.',
      },
      rewardsCall: {
        q: 'O aviso de que alguém está esperando tem limite?',
        a: 'Paga **1** moeda extra, até **20** vezes por dia. Depois disso, o aviso continua e essa moeda extra não é paga. Reinicia à meia-noite UTC.',
      },
      rewardsDaily: {
        q: 'As missões diárias e a corrida reiniciam?',
        a: 'Sim, à meia-noite UTC. Cada missão e cada meta da corrida pagam **3** moedas. Completar **7** das **10** missões diárias dá um pacote da loja. As missões de coleção não reiniciam.',
      },
    },
  },
  dialog: {
    snoozeToday: 'Não mostrar mais hoje',
  },
  eventQueueDialog: {
    kicker: 'Esta semana',
    title: 'Fila de evento',
    lead:
      'Uma fila rotativa por vez. As **vitórias** entram num ranking público. Ranqueado e casual não mudam.',
    duelPay:
      'Cada duelo terminado paga **7** moedas na vitória e **5** na derrota ou empate, igual ao ranqueado. Desistir não paga.',
    prizes:
      'Quando a semana fecha, a porcentagem conta quem ganhou pelo menos um duelo. Você recebe uma faixa só de Master Packs: **20** o top 1%, **15** o resto do top 10%, **8** o resto do top 25%, **4** o resto do top 50% e **2** o resto. Um empate em vitórias e derrotas no corte recebe a faixa de cima.',
    live: 'Ao vivo',
    play: 'Entrar na fila',
    board: 'Ver o ranking',
    modes: {
      random_deck:
        'Cada duelo te dá uma lista Standard nova. Você não escolhe o baralho.',
      unlimited:
        'Suas cartas. Três cópias de qualquer nome, sem banlist da casa. 40–60 no Main.',
      one_copy:
        'Suas cartas. Pelo menos 60 no Main, e só uma cópia de cada nome.',
    },
  },
  lastCallDialog: {
    kicker: 'Evento',
    lead:
      'Durante duas semanas, as partidas ranqueadas PVP terminadas desbloqueiam uma moldura, um retrato, uma capa, um tapete e um pacote promo. A Blue-Eyes promo pode ser reciclada como qualquer outra cópia.',
    foil:
      'O pacote traz um Blue-Eyes White Dragon em um foil aleatório acima de Super Rare.',
    rules:
      'Uma derrota também conta. Contra a CPU, as salas privadas e sair da partida não contam.',
  },
  missions: {
    kicker: 'Diárias',
    title: 'Missões',
    tabs: {
      daily: 'Diárias',
      runner: 'Corrida',
      ranked: 'Ranqueado',
      collection: 'Coleção',
      lastCall: 'Última chamada',
    },
    runner: {
      lead:
        'As mesmas cinco todo dia, da corrida da fila. Conta no ranqueado, no casual e na fila de evento. Cada uma paga 3 moedas. Reiniciam à meia-noite UTC e não entram no quadro de 10.',
      'runner-cards-5': 'Pule 5 cartas',
      'runner-cards-20': 'Pule 20 cartas hoje',
      'runner-cards-40': 'Pule 40 cartas hoje',
      'runner-steps-100': 'Chegue a 100 passos em uma corrida',
      'runner-steps-400': 'Chegue a 400 passos em uma corrida',
    },
    collection: {
      lead:
        'Essas missões não reiniciam. Cada etapa paga uma vez e conta as cartas que você já tem. As etapas mais difíceis também dão um pacote da loja.',
      family: {
        total: 'Total',
        set: 'Sets',
        kind: 'Tipos',
        attribute: 'Atributos',
        race: 'Raças',
        foil: 'Raridade',
        playset: 'Três cópias',
      },
      total: 'Colecione {n} cartas diferentes',
      totalAll: 'Complete a coleção',
      set: 'Colecione {n} cartas de {set}',
      setAll: 'Complete {set}',
      kind: 'Colecione {n} {kind}',
      attr: 'Colecione {n} cartas de {attr}',
      attrAll: 'Complete {attr}',
      race: 'Colecione {n} cartas de {race}',
      raceAll: 'Complete {race}',
      foil: 'Consiga {n} cartas {foil}',
      playset: 'Monte {n} grupos de 3 cópias',
      kinds: {
        normal: 'monstros normais',
        effect: 'monstros de efeito',
        spell: 'cards de magia',
        trap: 'cards de armadilha',
        fusion: 'monstros de fusão',
      },
      kindAll: {
        normal: 'Complete os monstros normais',
        effect: 'Complete os monstros de efeito',
        spell: 'Complete os cards de magia',
        trap: 'Complete os cards de armadilha',
        fusion: 'Complete os monstros de fusão',
      },
      foils: {
        rare: 'Raras ou melhores',
        super: 'Super Raras ou melhores',
        ultra: 'Ultra Raras ou melhores',
        special: 'com impressão especial',
      },
      packWinOne:
        'Essa etapa da coleção deixou um pacote da loja com os seus pacotes. Você pode abri-lo quando quiser.',
      packWinMany:
        'Essas etapas da coleção deixaram {n} pacotes da loja com os seus pacotes. Você pode abri-los quando quiser.',
    },
    lead:
      'Complete 7 de 10 para um pacote da loja. Cada missão paga 3 moedas. Reinicia à meia-noite UTC.',
    rankedLead:
      'As etapas 1 a 9 pagam 3 moedas cada uma. A etapa 7 dá um pacote da loja e a etapa 10 dá dois. Se você abandonar a partida, essa etapa não conta. Reinicia à meia-noite UTC.',
    rankedOne: 'Termine 1 partida ranqueada',
    rankedMany: 'Termine {n} partidas ranqueadas',
    rankedPackWinLead:
      'Você terminou {n} partidas ranqueadas hoje. O pacote da loja já está com os seus pacotes e você pode abri-lo quando quiser.',
    rankedPackWinMany:
      'Você terminou {n} partidas ranqueadas hoje. Os {packs} pacotes da loja já estão com os seus pacotes e você pode abri-los quando quiser.',
    lastCallLead:
      'Termine partidas ranqueadas PVP durante estas duas semanas. Contra a CPU, as salas privadas e sair da partida não contam. A Blue-Eyes promo pode ser reciclada como qualquer outra cópia.',
    lastCallClosed:
      'A Última chamada está fechada. O que você não alcançou não é entregue.',
    lastCallFrozen: 'A lista está congelada.',
    lastCallUntil: 'Fecha em {date} UTC.',
    lastCall: {
      frame: 'Moldura de avatar',
      portrait: 'Retrato de Blue-Eyes',
      sleeve: 'Capa de carta',
      mat: 'Tapete',
      pack: 'Pacote promo: Blue-Eyes White Dragon',
    },
    toastRanked: 'A partida ranqueada {n} está pronta para resgatar',
    back: '← Voltar ao início',
    empty: 'Não há missões disponíveis agora.',
    loadError: 'Não foi possível carregar as missões.',
    retry: 'Tentar de novo',
    claim: 'Recolher',
    claimAll: 'Recolher tudo',
    claimCta: 'Resgatar',
    claimed: 'Recolhido',
    progress: '{current} / {target}',
    remaining: 'Faltam {n} missões para o seu pacote',
    remainingOne: 'Falta 1 missão para o seu pacote',
    packUnlocked: 'Pacote liberado!',
    packPrize: 'Pacote da loja',
    packWinKicker: 'Recompensa',
    packWinTitle: 'Você ganhou um pacote!',
    packWinLead:
      'Você completou {n} missões diárias. O pacote da loja já está com os seus pacotes e você pode abri-lo quando quiser.',
    packWinOpen: 'Ir aos pacotes',
    packWinClose: 'Entendi',
    railHint: 'Cada etapa paga 3 moedas extra',
    stepClaim: 'Recolher etapa {n}',
    stepClaimed: 'Etapa {n} recolhida',
    stepDone: 'Missão {n} completa',
    stepTodo: 'Missão {n}',
    resetHint: 'Reinicia em {h}h {m}m (meia-noite UTC).',
    toastDone: 'Completou: {name}',
    toastDoneMany: 'Você completou {n} missões',
    toastHint: 'Abra Missões para resgatar sua recompensa.',
    pendingBadge: '{n} para resgatar',
    category: {
      presence: 'Jogar',
      skill: 'Habilidade',
      flavor: 'Duelo',
    },
    ids: {
      'play-1': 'Termine 1 duelo',
      'play-ai-1': 'Jogue 1 duelo contra a CPU',
      'open-pack-1': 'Abra 1 pacote',
      'draw-15': 'Compre 15 cards',
      'play-3': 'Termine 3 duelos',
      'play-ai-3': 'Jogue 3 duelos contra a CPU',
      'xp-40': 'Ganhe 40 XP em duelos',
      'draw-40': 'Compre 40 cards',
      'open-pack-2': 'Abra 2 pacotes',
      'play-5': 'Termine 5 duelos',
      'xp-90': 'Ganhe 90 XP em duelos',
      'draw-80': 'Compre 80 cards',
      'open-pack-5': 'Abra 5 pacotes',
      'win-1': 'Vença 1 duelo',
      'win-lp-1': 'Vença 1 duelo reduzindo os Pontos de Vida a 0',
      'survive-2000-1': 'Vença 1 duelo com 2000 ou mais Pontos de Vida',
      'win-2': 'Vença 2 duelos',
      'win-ai-hard-1': 'Vença a CPU em Difícil ou acima',
      'win-fast-1': 'Vença 1 duelo em 8 turnos ou menos',
      'survive-2000-2': 'Vença 2 duelos com 2000 ou mais Pontos de Vida',
      'win-lp-2': 'Vença 2 duelos reduzindo os Pontos de Vida a 0',
      'win-4': 'Vença 4 duelos',
      'win-ai-hard-3': 'Vença a CPU em Difícil ou acima 3 vezes',
      'win-fast-2': 'Vença 2 duelos em 8 turnos ou menos',
      'survive-2000-4': 'Vença 4 duelos com 2000 ou mais Pontos de Vida',
      'win-lp-4': 'Vença 4 duelos reduzindo os Pontos de Vida a 0',
      'summon-8': 'Invoque 8 monstros',
      'attack-10': 'Declare 10 ataques',
      'spell-5': 'Ative 5 Cards de Magia',
      'damage-2000': 'Cause 2000 ou mais de dano de batalha em um turno',
      'summon-20': 'Invoque 20 monstros',
      'attack-25': 'Declare 25 ataques',
      'spell-15': 'Ative 15 Cards de Magia',
      'trap-6': 'Ative 6 Cards de Armadilha',
      'tribute-5': 'Faça 5 Invocações por Tributo',
      'fusion-1': 'Faça 1 Invocação por Fusão',
      'damage-3500': 'Cause 3500 ou mais de dano de batalha em um turno',
      'summon-40': 'Invoque 40 monstros',
      'attack-45': 'Declare 45 ataques',
      'spell-28': 'Ative 28 Cards de Magia',
      'trap-12': 'Ative 12 Cards de Armadilha',
      'tribute-10': 'Faça 10 Invocações por Tributo',
      'fusion-3': 'Faça 3 Invocações por Fusão',
      'damage-5000': 'Cause 5000 ou mais de dano de batalha em um turno',
    },
  },
  settings: {
    title: 'Ajustes',
    lead: 'Como o app se comporta e como os menus aparecem neste aparelho.',
    tabs: {
      play: 'Jogo',
      look: 'Menus',
      dev: 'Dev',
    },
    appearance: 'Aparência',
    theme: 'Tema',
    themeHint: 'As telas de menu seguem isto. O tabuleiro do duelo continua escuro.',
    fullscreen: 'Tela cheia',
    fullscreenHint:
      'Esconde as barras do navegador. Num duelo, o menu de cima também some para o tabuleiro ficar maior. Pressione Esc para sair.',
    pushTitle: 'Avisos do torneio',
    pushHint: 'A contagem e o aviso de partida pronta, mesmo com o app fechado.',
    pushEnable: 'Ativar avisos',
    pushDisable: 'Desativar avisos',
    pushOn: 'Este aparelho recebe os avisos do torneio com o app fechado.',
    pushMuted: 'Os avisos do torneio estão desligados neste aparelho.',
    pushDenied: 'Os avisos estão bloqueados. Ative-os para o Dueling Chaos nos ajustes do Android.',
    pushUnsupported: 'Este navegador não pode mostrar avisos com o app fechado.',
    light: 'Claro',
    dark: 'Escuro',
    accent: 'Cor de destaque',
    accentHint: 'Usada na página selecionada, nos chips e nos destaques.',
    custom: 'Cor personalizada',
    preview: 'Prévia',
    presets: {
      gold: 'Ouro',
      orange: 'Laranja',
      coral: 'Coral',
      rose: 'Rosa',
      pink: 'Pink',
      violet: 'Violeta',
      indigo: 'Índigo',
      blue: 'Azul',
      cyan: 'Ciano',
      teal: 'Verde-azulado',
      green: 'Verde',
      silver: 'Prata',
    },
    vsAi: 'Duelo contra a IA',
    vsAiHint:
      'Só vale contra o computador. Duelos online sempre rolam o dado.',
    vsAiDifficulty: 'Dificuldade da CPU',
    vsAiDifficultyHint:
      'Cada duelo contra a IA escolhe uma receita publicada diferente dessa dificuldade. ' +
      'Níveis mais altos jogam listas mais fortes. Todas as dificuldades seguem a banlist, e o seu baralho também. Vencer em Difícil, Especialista ou Mestre ' +
      'paga mais moedas e XP. Cada duelo terminado paga moedas.',
    rankedPrompts: 'Avisos da ranqueada',
    rankedPromptsHint:
      'Avisos de que alguém espera uma ranqueada. Terminar essa partida paga 1 moeda, até 20 vezes por dia. Depois de 20, o aviso continua e essa partida não paga a moeda extra. Se você desligar, eles somem e essa moeda não é paga.',
    rankedPromptsOn: 'Mostrar avisos da ranqueada',
    vsAiTestHint:
      'A CPU só joga monstros normais de pouco ATK. Este duelo não dá moedas nem XP.',
    vsAiLevels: {
      test: 'Teste',
      easy: 'Fácil',
      normal: 'Normal',
      hard: 'Difícil',
      expert: 'Especialista',
      master: 'Mestre',
    },
    vsAiDecide: 'Como se decide o primeiro turno',
    vsAiDiceOn: 'Dado',
    vsAiDiceOff: 'Escolher',
    vsAiFirst: 'Quem começa',
    vsAiYou: 'Você',
    vsAiCpu: 'CPU',
    mat: 'Tapete',
    matHint:
      'A sua metade do campo. Online, o outro duelista vê este tapete. Contra a IA, a CPU recebe um tapete aleatório a cada duelo.',
    followOpponent: 'Seguir o oponente no visualizador',
    followOpponentHint:
      'Quando ele invoca, ativa ou ataca, esse card aparece no visualizador.',
    hideCardViewer: 'Ocultar o painel de cards',
    hideCardViewerHint:
      'Guarda o texto da direita para o campo ficar mais largo. Listas como Monster Reborn e Big Eye escondem sozinhas enquanto você escolhe.',
    coinQuality: 'Qualidade da animação da moeda',
    coinQualityHint:
      'Alta gira a moeda em 3D. Baixa gira a mesma moeda no plano, e pesa menos se o diálogo 3D travava o duelo. Fica neste aparelho.',
    coinQualityLevel: {
      high: 'Alta',
      low: 'Baixa',
    },
    motion: 'Animações',
    motionHint:
      'Completas mantém partículas e voos. Reduzidas corta partículas, tremores e efeitos de campo; os cards continuam se movendo. Mínimas deixa os cards no lugar, sem voos 3D, sem foil animado e sem o fundo de campo. Fica neste aparelho.',
    motionLevel: {
      full: 'Completas',
      reduced: 'Reduzidas',
      minimal: 'Mínimas',
    },
    imageQuality: 'Qualidade da imagem',
    imageQualityHint:
      'Nítida detalha os cards, as capas e os números de ATK e DEF. Essa é a que já vem escolhida. Padrão pede menos do celular se a tela pesar. Atualize a página para ver a mudança. Fica neste aparelho.',
    imageQualityApply: 'Atualize a página para aplicar esta mudança.',
    imageQualityLevel: {
      sharp: 'Nítida',
      standard: 'Padrão',
    },
    foilSweep: 'Brilho do foil',
    foilSweepHint:
      'Completo é o brilho de sempre sobre o card. Leve pede menos do celular quando o baralho está cheio de foil, e o brilho fica mais simples. Fica neste aparelho.',
    foilSweepMode: {
      full: 'Completo',
      light: 'Leve',
    },
    foilThumbs: 'Animar o foil nas miniaturas',
    foilThumbsHint:
      'O álbum, o baú e as listas varrem cada foil. Desligado, esses cards ficam com um tom parado e só enquanto estão na tela. O card aberto continua brilhando. Fica neste aparelho.',
    responseMode: 'Quando perguntar sobre armadilhas',
    responseModeHint:
      'Mínimo é o que já vem escolhido: só pergunta quando uma armadilha responde àquela jogada. Just Desserts também pergunta uma vez no começo da Fase de Batalha do oponente, se ele controlar um monstro. Ultimate Offering virada para baixo também pergunta aí, e de novo quando ele declara um ataque. Robbin\' Goblin pergunta no começo da sua Fase de Batalha, e quando o oponente ataca um monstro seu virado para baixo em Defesa que devolveria dano. As Counter Trap só perguntam quando o oponente ativa ou invoca algo que elas podem negar. Auto também pergunta em invocações, ataques e no começo da Fase de Batalha. Tudo pergunta em cada fase. Desligado nunca pergunta.',
    focusBands: 'Aproximar o campo no celular',
    focusBandsHint:
      'Em paisagem, a câmera fica na sua mão, segue uma jogada e volta. Um botão e um toque trocam a vista.',
    matOpacity: 'Opacidade',
    matRandom: 'Aleatório',
    matRandomHint: 'Um tapete diferente a cada duelo.',
    matCartoon: 'Desenho',
    matFlat: 'Liso',
    sleeve: 'Protetor',
    sleeveHint:
      'Cards virados para baixo e o seu baralho. Contra a IA, a CPU recebe um protetor aleatório a cada duelo.',
    sleeveRandom: 'Aleatório',
    sleeveRandomHint: 'Um protetor diferente a cada duelo.',
    leagueRewards: 'Prêmios de liga',
    leagueLocked: 'Chegue à liga {league}',
    duel: 'Duelo',
    duelHint:
      'Visualizador, arte dos cards e tapete de todo duelo neste aparelho.',
    cardArt: 'Arte do card',
    cardArtHint:
      'A imagem no card. TCG é a ilustração internacional padrão; ' +
      'OCG é a original japonesa. A maioria dos cards coincide. Alguns, como ' +
      'Monster Reborn, ficam diferentes.',
    cardArtTcg: 'TCG',
    cardArtOcg: 'OCG',
    audio: 'Áudio',
    audioHint:
      'Música e efeitos do duelo. Os dois controles valem nos menus, nos pacotes e nos ' +
      'duelos. Som do duelo desligado silencia efeitos e música até você ' +
      'ligar de novo.',
    music: 'Música',
    sfx: 'Efeitos sonoros',
    sleeves: {
      'millennium-gaze': 'Olhar do Milênio',
      'heart-draw': 'Compra do Coração',
      'kingdom-isle': 'Ilha do Reino',
      'city-skies': 'Céus da Cidade',
      'god-triad': 'Tríade dos Deuses',
      'ivory-wyrm': 'Serpe de Marfim',
      'dusk-staff': 'Cajado do Crepúsculo',
      'carnival-ink': 'Tinta de Carnaval',
      'crimson-iris': 'Íris Carmesim',
      'five-relics': 'Cinco Relíquias',
      'classic-vortex': 'Vórtice Clássico',
      'sapphire-vortex': 'Vórtice Safira',
      'emerald-vortex': 'Vórtice Esmeralda',
      'amethyst-vortex': 'Vórtice Ametista',
      'rose-vortex': 'Vórtice Rosa',
      'silver-vortex': 'Vórtice Prateado',
      'last-call': 'Última chamada',
      'league-duelist': 'Duelista',
      'league-challenger': 'Desafiante',
      'league-champion': 'Campeão',
      'league-king': 'Rei dos Jogos',
    },
    mats: {
      'puzzle-dusk': 'Crepúsculo do quebra-cabeça',
      'white-sky': 'Céu branco',
      'moon-circle': 'Círculo da lua',
      'ember-wings': 'Asas de brasa',
      'sogen-hills': 'Colinas verdes',
      'umi-tide': 'Maré',
      'sand-temple': 'Templo de areia',
      'toon-fair': 'Carnaval',
      'shadow-chains': 'Correntes de sombra',
      'kingdom-arena': 'Arena de duelo',
      'mystic-circle': 'Círculo místico',
      'forbidden-seal': 'Selo proibido',
      'knight-charge': 'Carga do cavaleiro',
      'elf-grove': 'Bosque élfico',
      'light-swords': 'Espadas de luz',
      'navy-puzzle': 'Quebra-cabeça marinho',
      'crimson-eye': 'Olho carmesim',
      'forest-leaf': 'Folha da floresta',
      'gold-star': 'Estrela de ouro',
      'violet-moon': 'Lua violeta',
      'charcoal-hex': 'Hexágono de carvão',
      'teal-drop': 'Gota verde-azulada',
      'ember-flame': 'Chama de brasa',
      'ivory-disk': 'Disco de marfim',
      'slate-tribute': 'Tributo de ardósia',
      'last-call': 'Última chamada',
      'league-duelist': 'Duelista',
      'league-challenger': 'Desafiante',
      'league-champion': 'Campeão',
      'league-king': 'Rei dos Jogos',
    },
    devTools: 'DevTools',
    devToolsHint: 'Ferramentas de desenvolvimento. Digite a senha para desbloquear.',
    devToolsPassword: 'Senha',
    devToolsUnlock: 'Desbloquear',
    devToolsWrong: 'Senha incorreta.',
    devToolsGrant: 'Conceder todos os cards',
    devToolsGrantHint:
      'Coloca cada card do catálogo na sua coleção, com 3 cópias de cada raridade.',
    devToolsGranted: 'Pronto. Veja a Coleção ou monte um baralho.',
    devToolsPacksHint:
      'Adiciona Master Packs fechados. Abra-os em Pacotes. Sem gastar moedas.',
    devToolsPacksX5: 'Resgatar x5',
    devToolsPacksX10: 'Resgatar x10',
    devToolsPacksGranted: 'Foram adicionados {n} pacotes. Abra-os em Pacotes.',
    devToolsFailed: 'Não foi possível aplicar. Entre e tente de novo.',
    devToolsLock: 'Bloquear',
    devToolsReset: 'Redefinir esta conta',
    devToolsResetHint:
      'Apaga coleção, baralhos, moedas, XP e a liga. Você recomeça com os três starters.',
    devToolsResetDone: 'Conta redefinida. Abra seus starters em Pacotes.',
    devToolsCoins: 'Adicionar 100 moedas',
    devToolsCoinsDone: 'Foram adicionadas 100 moedas.',
    devToolsRank: 'Definir liga ranqueada',
    devToolsRankHint: 'Pula a colocação e grava esta liga na conta.',
    devToolsRankDone: 'Liga atualizada.',
    devToolsPlacement: 'Colocação',
  },
  feedback: {
    title: 'Caixa de correio',
    lead:
      'Sugestões, reclamações ou um bug. Você está conectado, então sabemos quem enviou.',
    kind: 'Sobre o que é',
    kinds: {
      suggestion: 'Sugestão',
      complaint: 'Reclamação',
      bug: 'Bug',
    },
    reportBug: 'Reportar um bug',
    message: 'Mensagem',
    placeholder: 'O que aconteceu, ou o que você mudaria…',
    send: 'Enviar',
    thanks: 'Obrigado. Lemos cada nota.',
    thanksBug:
      'Obrigado. Se o bug for real, você ganha 1 moeda e 1 Master Pack depois que a gente conferir.',
    thanksCoin: 'Obrigado. Você ganhou 1 moeda.',
    thanksCoinDone: 'Obrigado. A moeda de hoje já está na sua conta.',
    rate: 'Você já enviou várias notas hoje. Tente de novo amanhã.',
    error: 'Não foi possível enviar. Escreva um pouco mais e tente de novo.',
  },
  lobby: {
    title: 'Sala online',
    quickMatch: 'Partida rápida',
    queueWaiting: '{n} na fila',
    queueClosed: 'O ranqueado está em pausa. Tente de novo em alguns minutos.',
    rankedOffer: 'Jogue uma e ganhe {n} moedas.',
    rankedHint: 'Ranqueado. Sua liga está no seu perfil.',
    casual: 'Fila casual',
    casualHint: 'Sua liga não muda.',
    eventHint: 'Evento semanal. 7 moedas na vitória, 5 na derrota ou empate, igual ao ranqueado. Sua liga não muda. No fechamento, Master Packs por porcentagem: 20 o top 1%, 15 o resto do top 10%, 8 o resto do top 25%, 4 o resto do top 50% e 2 o resto.',
    privateRooms: 'Salas privadas',
    privateHint: 'Não é ranqueado. Salas abertas esperam um segundo duelista.',
    watch: 'Assistir duelos',
    watchHint: 'PvP em andamento. Você vê o campo, não as mãos.',
    back: '← Voltar',
    using: 'Usando: {name}',
    playDeck: 'Duelar com',
    deckNotReady: ' (não está pronto)',
    edit: 'Editar',
    buildDeck: 'Montar um baralho',
  },
  rooms: {
    title: 'Salas privadas',
    lead: 'Não é ranqueado. Crie uma sala ou entre em uma que está esperando.',
    create: 'Criar uma sala',
    join: 'Entrar',
    joinCode: 'Entrar com um código',
    codePlaceholder: 'CÓDIGO',
    empty: 'Nenhuma sala esperando. Crie uma, ou peça o código a um amigo.',
    seats: '{taken}/{max}',
    back: '← Sala',
    connecting: 'Carregando salas…',
    error: 'Não foi possível alcançar o servidor. Confira sua conexão.',
    badCode: 'Digite o código de 4 caracteres da sala.',
    yours: 'Sua',
  },
  watch: {
    title: 'Assistir duelos',
    lead: 'Partidas ranqueadas e salas privadas em andamento. As mãos e as cartas viradas para baixo ficam ocultas.',
    filter: 'Mostrar',
    all: 'Todos',
    ranked: 'Ranqueadas',
    event: 'Evento',
    casual: 'Salas privadas',
    empty: 'Nenhum duelo em andamento.',
    connecting: 'Carregando duelos…',
    error: 'Não foi possível alcançar o servidor. Confira sua conexão.',
    watch: 'Assistir',
    yours: 'Seu duelo',
    back: '← Início',
    hand: 'Mão',
    deck: 'Baralho',
    modeRanked: 'Ranqueada',
    modeEvent: 'Evento',
    modeCasual: 'Sala privada',
    offline: 'offline',
  },
  packs: {
    title: 'Pacotes',
    yours: 'Seus pacotes',
    empty: 'Você não tem pacotes fechados. Compre um na loja ou comece como jogador novo.',
    shop: 'Loja',
    shopNote: 'Vença duelos ou complete missões diárias para ganhar moedas. Um pacote da loja custa:',
    open: 'Abrir',
    opening: 'Abrindo…',
    openFailed: 'O pacote não abriu. Tente de novo.',
    openThree: 'Abrir 3',
    openFive: 'Abrir 5',
    openTen: 'Abrir 10',
    openAnother: 'Abrir outro',
    packOf: 'Pacote {n} / {total}',
    nextPack: 'Próximo pacote',
    tapNextPack: 'Toque para abrir o próximo pacote',
    claim: 'Resgatar pacote',
    buy: 'Comprar pacote',
    buyThree: 'Comprar 3',
    buyFive: 'Comprar 5',
    buyTen: 'Comprar 10',
    buying: 'Comprando…',
    buyFailed: 'O pacote não foi comprado. Tente de novo.',
    buyNeedCoins: 'Moedas insuficientes.',
    buyRate: 'Compras demais. Espere um momento e tente de novo.',
    buySignedOut: 'Entre de novo para comprar um pacote.',
    boughtOne: '+1 pacote',
    boughtMany: '+{n} pacotes',
    price: '{n} moedas',
    have: 'Você tem x{count}',
    complete: '{percent}%',
    completeOf: '{owned} / {total}',
    completeAria: '{percent} por cento. {owned} de {total} cards',
    contents: 'Cartas',
    contentsProgress: '{owned} / {total} · {percent}%',
    haveCard: 'Você tem este card',
    contentsSearch: 'Buscar uma carta',
    contentsCount: '{n} cartas',
    contentsEmpty: 'Nenhuma carta coincide.',
    contentsChase:
      'Uma Ultra ou Secret também pode sair Ghost, Helios, Nightglass ou Stormwake.',
    contentsMaster: 'Qualquer carta do jogo. Cada cópia tira o próprio foil.',
    collection: 'Coleção',
    vaultLabel: 'Kaiba Corp',
    binderLabel: 'Coleção',
    tagline: {
      'starter-beasts': 'Starter · 20 monstros · Blue-Eyes',
      'starter-runes': 'Starter · 20 magias e armadilhas · Swords',
      'starter-crucible': 'Starter · 5 Deck Adicional · Gaia',
      'shop-onyx': 'Especial · 5 cards do conjunto',
      'set-lob': '9 cartas · Legend of Blue-Eyes e os starters',
      'promo-lob': 'Promo · 1 Blue-Eyes White Dragon',
      'set-mrd': '9 cartas · Metal Raiders',
      'promo-mrd': 'Especial · 5 cartas de Metal Raiders · Ultra Rare ou mais',
      'set-mrl': '9 cartas · Magic Ruler',
    },
    names: {
      'starter-beasts': 'Legend of Blue Eyes White Dragon',
      'starter-runes': 'Swords of Light',
      'starter-crucible': 'Gaia the Dragon Champion',
      'set-lob': 'Legend of Blue Eyes White Dragon',
      'promo-lob': 'Pacote promo',
      'set-mrd': 'Pacote de Metal Raiders',
      'promo-mrd': 'Pacote especial de Metal Raiders',
      'set-mrl': 'Pacote de Magic Ruler',
    },
    rarity: {
      common: 'Comum',
      rare: 'Raro',
      super: 'Super Raro',
      ultra: 'Ultra Raro',
      ghost: 'Ghost Rare',
      secret: 'Raro Secreto',
      helios: 'Helios Rare',
      nightglass: 'Nightglass Rare',
      stormwake: 'Stormwake Rare',
    },
    sfxOn: 'Som ligado',
    sfxOff: 'Som desligado',
    skip: 'Pular',
    tearHint: 'Segure o pacote e deslize para abrir',
    openBtn: 'Abrir',
    new: 'Novo',
    tapReveal: 'Toque para revelar',
    tapLast: 'O último… toque para revelar',
    tapNext: 'Toque para o próximo card',
    tapSummary: 'Toque para ver o resumo',
    done: 'Pronto',
    toDeck: 'Ir ao baralho',
  },
  collection: {
    kicker: 'Álbum',
    title: 'Coleção',
    lead: 'Um espaço por card. LOB primeiro, depois Starter Deck: Yugi e Kaiba.',
    openPacks: 'Abrir pacotes',
    search: 'Buscar nome ou LOB / SDY / SDK…',
    filter: 'Mostrar',
    all: 'Todos',
    owned: 'Tenho',
    missing: 'Faltam',
    setFilter: 'Conjunto',
    setAll: 'Todos os conjuntos',
    progress: '{owned} de {total} cards',
    emptyFilter: 'Nenhum card combina com estes filtros.',
    loading: 'Carregando coleção…',
    preferredFoil: 'Raridade preferida',
    slotEmpty: 'Este espaço está vazio. Você ainda não tem este card.',
    searchFilters: 'Busca e filtros',
    applyFilters: 'Aplicar',
    resetFilters: 'Limpar filtros',
    clearSearch: 'Limpar busca',
  },
  welcome: {
    kicker: 'Bem-vindo',
    title: 'Seus primeiros pacotes',
    lead:
      'Você começa com três pacotes starter e três Master Packs (cinco ' +
      'cards cada). Abra-os, monte um baralho de 40 cards e aí pode duelar. Se ' +
      'você limpar o armazenamento deste navegador, volta a ser um jogador novo.',
    cta: 'Ver meus pacotes',
  },
  needDeck: {
    title: 'Monte um baralho de 40 cards',
    body: 'Os duelos usam só cards que você tirou dos pacotes. Abra seus pacotes e salve um Baralho Principal de pelo menos 40 cards.',
    toPacks: 'Ir aos pacotes',
    deckBuilder: 'Construtor de baralho',
  },
  deck: {
    title: 'Construtor de baralho',
    backHome: '← Voltar ao início',
    collection: 'Coleção de cards',
    tabCollection: 'Coleção',
    tabTrunk: 'Baú',
    tabDeck: 'Baralho',
    showTrunk: 'Ver baú',
    showDeck: 'Ver baralho',
    ownedOnly: 'Só cards tirados dos pacotes.',
    openPacks: 'Abrir pacotes',
    search: 'Buscar cards...',
    clearSearch: 'Limpar busca',
    searchFilters: 'Busca e filtros',
    applyFilters: 'Aplicar',
    allTypes: 'Todos os tipos',
    allMonsters: 'Todos os monstros',
    spell: 'Magia',
    trap: 'Armadilha',
    allAttributes: 'Todos os atributos',
    allLevels: 'Todos os níveis',
    allRaces: 'Todos os tipos',
    allSubtypes: 'Todos os subtipos',
    allRarities: 'Todas as raridades',
    allSets: 'Todos os conjuntos',
    availabilityAll: 'Todos',
    availabilityFree: 'Cópias restantes',
    availabilityNotInDeck: 'Fora do baralho',
    sortBy: 'Ordenar por',
    sortNameAsc: 'Nome A–Z',
    sortNameDesc: 'Nome Z–A',
    sortAcquiredDesc: 'Obtido (mais novo)',
    sortAcquiredAsc: 'Obtido (mais antigo)',
    sortLevelDesc: 'Nível (alto)',
    sortLevelAsc: 'Nível (baixo)',
    sortAtkDesc: 'ATK (alto)',
    sortAtkAsc: 'ATK (baixo)',
    sortDefDesc: 'DEF (alto)',
    sortDefAsc: 'DEF (baixo)',
    sortType: 'Tipo',
    sortRarity: 'Raridade',
    sortSet: 'Conjunto (LOB primeiro)',
    resetFilters: 'Limpar filtros',
    moreFilters: 'Mais filtros',
    fewerFilters: 'Ocultar filtros',
    emptyCollection: 'Você ainda não tem cards.',
    openForCards: 'Abra pacotes para conseguir cards',
    currentDeck: 'Baralho atual',
    min40: 'Mín.: 40',
    autoBuild: 'Montar sozinho',
    autoNeed: 'Você precisa de 40 cards no Baralho Principal. Você tem {n}.',
    autoHint: 'Respeita a banlist. 20 monstros + 20 magias/armadilhas, primeiro os que mais ganham nesta temporada.',
    sort: 'Ordenar',
    bestFoils: 'Melhores raridades',
    bestFoilsHint: 'Coloca no baralho as suas cópias mais raras de cada card.',
    undo: 'Desfazer',
    undoHint: 'Desfaz a última mudança deste baralho. Ctrl+Z.',
    undoNamed: 'Desfazer {name}',
    undoRestoreHint: 'Devolve {name} ao baralho. Ctrl+Z.',
    undoRestored: '{name} voltou ao baralho',
    undoDone: 'A última mudança foi desfeita',
    clear: 'Limpar baralho',
    monsters: 'Monstros',
    spells: 'Magias',
    traps: 'Armadilhas',
    emptyMain: 'Seu baralho está vazio',
    emptyMainHint: 'Toque para adicionar uma cópia. Segure para adicionar até 3.',
    pvpLimitBadge: 'Máximo {n}',
    banlistKicker: 'Metal Raiders',
    banlistTitle: 'Banlist',
    banlistLead:
      'Essas cartas passam do máximo de cópias. Reduza ao limite abaixo e tente de novo.',
    banlistRow: 'você tem {have} / máximo {max}',
    banlistClose: 'Fechar',
    banlistEdit: 'Editar baralho',
    extraDeck: 'Deck Adicional',
    emptyExtra: 'Nenhum monstro de fusão no Deck Adicional',
    addCopy: 'Adicionar ao baralho',
    removeCopy: 'Tirar do baralho',
    sheetAdd: 'Adicionar',
    sheetRemove: 'Tirar',
    copyFoil: 'Raridade desta cópia',
    deckName: 'Nome do baralho...',
    save: 'Salvar baralho',
    saved: 'Salvo!',
    addMore: 'Adicione mais {n} cards',
    defaultName: 'Meu baralho de Yu-Gi-Oh',
    myDeck: 'Meu baralho',
    buildForty: 'Monte um baralho de 40 cards',
    savedOk: 'Salvou “{name}”.',
    savedOkActive:
      'Salvo. Duelos contra a IA e online vão usar “{name}”. A IA usa um baralho Standard.',
    savedOther:
      'Salvou “{name}”. Os duelos ainda usam “{active}”. Escolha Usar nos duelos para trocar.',
    savedUnowned:
      'Salvo, mas algumas cópias não estão na sua coleção. Tire-as ou abra mais pacotes antes de poder duelar.',
    savedIllegal:
      'Salvo, mas esta lista não é legal (40–60 no Principal, no máximo 3 cópias, Fusões só no Adicional). Corrija para duelar.',
    savedDraft:
      'Salvo. Você pode continuar editando. Os duelos precisam de 40–60 cards do Baralho Principal que você tenha.',
    hintUnsaved: 'Mudanças sem salvar. Os duelos ainda usam “{name}” até você salvar.',
    hintEmpty: 'Salve quando quiser. Os duelos precisam de 40 cards do Baralho Principal que você tenha.',
    hintUnowned:
      'Esta lista salva usa cards que você não tem, então os duelos não começam.',
    hintIllegal: 'Esta lista salva não é legal, então os duelos não começam.',
    hintEditingOther:
      'Editando “{edit}”. Os duelos ainda usam “{active}” até você trocar.',
    newDeckCard: 'Novo baralho',
    openDeck: 'Editar este baralho',
    backToDecks: '← Seus baralhos',
    savedDecks: 'Seus baralhos',
    newDeck: 'Novo',
    duplicate: 'Duplicar',
    deleteDeck: 'Apagar',
    useInDuels: 'Usar nos duelos',
    inDuels: 'Nos duelos',
    tournamentLock: 'No torneio',
    tournamentLocked:
      'Este baralho está no torneio. Não dá para editar nem apagar até terminar ou você sair da inscrição.',
    deckLimit: 'Você pode salvar até 10 baralhos.',
    confirmDelete: 'Apagar “{name}”?',
    confirmDiscard: 'Descartar mudanças sem salvar?',
    copySuffix: 'cópia de {name}',
    useNeedLegal:
      'Esta lista precisa ser legal e sua (40–60 no Principal) antes de ir para um duelo.',
    addedCopies: 'Adicionou {n} ao baralho',
    holdToAddThree: 'Clique para adicionar 1. Segure para adicionar até 3.',
    deckList: 'Ver lista',
    deckListHint: 'O baralho inteiro em uma tela, pronto para capturar.',
    deckListShare: 'Compartilhar',
    deckListCopied: 'Copiada',
    deckListView: 'Vista da lista',
    deckListNames: 'Nomes',
    deckListSprites: 'Cards',
    deckListImage: 'Imagem',
    deckListImageBusy: 'Salvando…',
    deckListImageFail: 'Não foi possível salvar',
    deckListMain: 'Principal {n}',
    deckListExtra: 'Adicional {n}',
    recycle: 'Reciclar cópias',
  },
  recycle: {
    kicker: 'Baralhos',
    title: 'Reciclar cópias',
    back: '← Seus baralhos',
    empty: 'Você não tem cópias sobrando. Uma carta entra aqui quando você tem mais de 3.',
    rowCoins: '{n} moedas',
    summary: '{n} cópias · {coins} moedas',
    selectAll: 'Selecionar tudo',
    clear: 'Limpar seleção',
    selectScope: 'Vale para',
    lowerRarity: 'Raridade mais baixa',
    higherRarity: 'Raridade mais alta',
    selectHint: 'Marca cada cópia extra, começando por esta raridade. Ficam 3 de cada carta.',
    confirm: 'Reciclar',
    busy: 'Reciclando…',
    done: 'Você recebeu {n} moedas.',
    failed: 'Não foi possível reciclar. Tente de novo.',
    tournamentBlocked:
      'Você não pode reciclar enquanto estiver inscrito no torneio. Volta quando terminar, ou se você sair da inscrição.',
  },
  duel: {
    you: 'VOCÊ',
    opponent: 'OPONENTE',
    trap: 'Armadilha',
    field: 'CAMPO',
    chainBanner: 'Corrente',
    turn: 'Turno {n}',
    yourTurn: 'Seu turno',
    opponentTurn: 'Turno do oponente',
    youParen: '(Você)',
    opponentParen: '(Oponente)',
    phaseBanner: {
      draw: 'Fase de Compra',
      standby: 'Fase de Espera',
      main1: 'Fase Principal 1',
      battle: 'Fase de Batalha',
      main2: 'Fase Principal 2',
      end: 'Fase Final',
    },
    dice: {
      kicker: 'Primeiro jogador',
      title: 'Rolar para começar',
      hint: 'A rolagem mais alta começa o duelo.',
      roll: 'Rolar',
      rolling: 'Rolando…',
      tie: 'Empate! Rolando de novo…',
      youFirst: 'Você começa.',
      oppFirst: 'O oponente começa.',
      youFirstBig: 'Você começa!',
      namedFirst: '{name} começa!',
      cpu: 'CPU',
    },
    vs: {
      kicker: 'Começo do duelo',
      skip: 'Pular',
    },
    roster: {
      kicker: 'Duelistas',
      you: 'Você',
      rival: 'Rival',
      placement: 'Colocação',
      placementLeft: 'Faltam {n} duelos',
      noRank: 'Sem rank',
      level: 'Nível {n}',
      placeRanked: 'Ranqueado #{n}',
      placeLevel: 'Top de nível #{n}',
      placeAi: '{name} #{n}',
      record: '{wins}–{losses}',
      recordDraws: '{wins}–{losses}–{draws}',
      noDuels: 'Sem duelos',
      winStreak: '{n} vitórias seguidas',
      lossStreak: '{n} derrotas seguidas',
    },
    soundOn: 'Som ligado',
    soundOff: 'Som desligado',
    animSpeed1: 'Anim: lenta',
    animSpeed2: 'Anim: normal',
    animSpeed3: 'Anim: rápida',
    chat: {
      title: 'Chat',
      placeholder: 'Mensagem...',
      send: 'Enviar',
      show: 'Chat',
      hide: 'Ocultar chat',
    },
    roomCode: 'Código da sala:',
    back: 'Voltar',
    backHome: 'Voltar ao início',
    surrender: 'Desistir',
    surrenderConfirm: 'Desistir deste duelo? Você não ganha moedas nem XP.',
    leaveConfirm: 'Sair deste duelo? Ele termina agora e seu oponente vence.',
    tournamentLeaveConfirm: 'Se você sair da sala, perde esta partida.',
    tournamentLeave: 'Sair e perder',
    tournamentStay: 'Ficar',
    surrenderCancel: 'Continuar jogando',
    rankedCall: '{name} espera um duelo ranqueado.',
    rankedCallWait: 'Espera um duelo ranqueado.',
    rankedCallGo: 'Duelo',
    rankedCallGoPay: 'Duelo contra {name} por {n} moedas',
    rankedCallGoHint: 'Deixa este duelo e joga uma ranqueada contra {name}. Termine para receber as moedas.',
    rankedCallIgnore: 'Ignorar',
    viewerCard: 'Card',
    viewerSettings: 'Ajustes',
    viewerLog: 'Registro',
    viewerEmpty: 'Toque um card para vê-lo aqui.',
    viewerFaceDown: 'Card virado para baixo.',
    hideViewer: 'Ocultar info do card',
    showViewer: 'Mostrar info do card',
    gear: 'Ajustes do duelo',
    focusCycle: 'Trocar a vista do campo',
    shuffleHand: 'Embaralhar a mão',
    nextPhase: 'Próxima',
    holdToEndTurn: 'Segure para terminar o turno (pula Batalha e Principal 2)',
    response: {
      title: 'Armadilhas',
      auto: 'Auto',
      always: 'Tudo',
      minimal: 'Mínimo',
      off: 'Desligado',
      hint: 'Quando o jogo pergunta se você quer ativar uma armadilha. Toque para alternar Tudo, Auto, Mínimo e Desligado.',
    },
    connecting: 'Conectando...',
    reconnecting: 'A conexão caiu. Reconectando…',
    opponentReconnecting: 'Seu oponente perdeu a conexão. Ele tem um minuto para voltar.',
    watching: 'Assistindo ao duelo',
    spectators: 'Assistindo',
    spectatorsCount: '{n} assistindo',
    replay: {
      kicker: 'Replay',
      play: 'Reproduzir',
      pause: 'Pausa',
      step: 'Passo',
      speed: '{n}×',
      speedLabel: 'Velocidade {n}×',
      collapse: 'Recolher controles',
      expand: 'Estender controles',
      move: 'Arraste para mover',
      loading: 'Carregando o replay…',
      missing: 'Este replay não está mais disponível.',
      stale: 'Este replay não pode ser visto com as regras atuais.',
    },
    watchWaiting: 'Esperando {name}',
    watchWinner: '{name} venceu',
    watchDraw: 'O duelo terminou',
    watchBack: 'Voltar ao painel',
    watchBackList: 'Voltar à lista',
    watchOver: {
      lifePoints: 'Os Pontos de Vida de um jogador chegaram a 0.',
      deckOut: 'Um jogador não pôde comprar um card.',
      exodia: 'Um jogador reuniu as cinco partes de Exodia.',
      surrender: 'Um jogador desistiu.',
      forfeit: 'Um jogador saiu da sala.',
      timeout: 'O relógio de um jogador acabou.',
      roundTime: 'O tempo da rodada acabou.',
    },
    creating: 'Criando sala...',
    joining: 'Entrando na sala...',
    searching: 'Procurando um oponente...',
    tournamentWait: 'Esperando sua partida do torneio...',
    tournamentWaitFor: 'Esperando {name}',
    tournamentAdvance: 'Você avança de fase.',
    tournamentTimeUp: 'O tempo acabou.',
    searchingCasual: 'Procurando um duelo casual. Sua liga não muda.',
    searchingEvent: 'Procurando um duelo de evento. Sua liga não muda.',
    searchingElapsed: 'Tempo na fila: {time}',
    searchingStill: 'Ainda procurando. A fila continua ativa.',
    queueWindowNear: 'Perto do seu rating (±{n})',
    queueWindowMid: 'Busca mais larga (±{n})',
    queueWindowOpen: 'Qualquer duelista na fila',
    queueWidenIn: 'Amplia em {n} s',
    queueOpenIn: 'Qualquer um entra em {n} s',
    queueStar: 'Toque a estrela',
    queueStarBonus: 'Estrela pequena',
    queueStarCount: '{n} estrelas',
    queueStarBest: 'Melhor: {n}',
    queueStarCoin: 'Uma moeda!',
    queueRun: 'Toque para pular',
    queueRunOver: 'Toque para continuar',
    queueRunCount: '{n} passos',
    waitingJoin: 'Esperando o oponente entrar...',
    victory: 'VITÓRIA',
    defeat: 'DERROTA',
    victorySub: 'Você venceu o duelo!',
    defeatSub: 'Seu oponente derrotou você.',
    overBy: {
      lifePointsWin: 'Os Pontos de Vida do oponente chegaram a 0.',
      lifePointsLose: 'Seus Pontos de Vida chegaram a 0.',
      deckOutWin: 'O oponente não pôde comprar um card.',
      deckOutLose: 'Você não pôde comprar um card.',
      exodiaWin: 'Você reuniu as cinco partes de Exodia na mão.',
      exodiaLose: 'O oponente reuniu as cinco partes de Exodia.',
      surrenderWin: 'O oponente desistiu.',
      surrenderLose: 'Você desistiu.',
      forfeitWin: 'O oponente saiu da sala.',
      forfeitLose: 'Você saiu da sala.',
      timeoutWin: 'O tempo do oponente acabou.',
      timeoutLose: 'Seu tempo acabou.',
      roundTimeWin: 'O tempo da rodada acabou.',
      roundTimeLose: 'O tempo da rodada acabou.',
      aiTooLong: 'Este duelo chegou a uma hora e foi encerrado. Sem moedas nem XP.',
      aiEnded: 'Este duelo foi encerrado. Sem moedas nem XP.',
    },
    clockHint: 'Tempo que você tem. Em zero, você perde. A troca de turno soma.',
    exodia: {
      kicker: 'O proibido',
      sub: 'As cinco partes, na mão',
      skip: 'Toque para pular',
    },
    reward: '+{n} moedas',
    rankedNudgePaid: 'Inclui {n} moedas por jogar a ranqueada.',
    rankedOffer: 'Jogue uma ranqueada e ganhe {n} moedas.',
    rankedOfferGo: 'Jogar ranqueada',
    playAgain: 'Jogar de novo',
    tournamentPrizes: 'Você recebe os prêmios no correio no fim do torneio.',
    returnLobby: 'Voltar à sala',
    youWin: 'VOCÊ VENCEU!',
    youLose: 'VOCÊ PERDEU',
    gameOver: 'FIM DE JOGO',
    backToMenu: 'Voltar ao menu',
    extraYours: 'Seu Deck Adicional',
    extraOpp: 'Deck Adicional do oponente',
    banishedYours: 'Seus cards banidos',
    banishedOpp: 'Cards banidos do oponente',
    gyYours: 'Seu Cemitério',
    gyOpp: 'Cemitério do oponente',
    log: {
      empty: 'As ações do duelo aparecem aqui.',
      aCard: 'um card',
      turn: 'Turno {n} — {name}',
      phase: '{name} — {phase}',
      draw: '{name} comprou {card}',
      drawHidden: '{name} comprou um card',
      summon: '{name} Invocou de Modo Normal {card}',
      tributeSummon: '{name} fez uma Invocação por Tributo de {card}',
      set: '{name} Baixou um card',
      flip: '{card} foi virado para cima',
      posAtk: '{card} mudou para Posição de Ataque',
      posDef: '{card} mudou para Posição de Defesa',
      spell: '{name} ativou {card}',
      trap: '{name} ativou {card}',
      effect: '{card}: efeito ativado',
      attack: '{card} ataca {target}',
      attackDirect: '{card} ataca diretamente',
      replay: '{card}: um Replay — escolha um novo ataque ou passe',
      destroy: '{card} foi destruído',
      banish: '{card} foi banido',
      toHand: '{card} voltou para a mão',
      lp: '{name}: {lp} LP ({delta})',
      gameOver: '{name} vence',
      message: '{text}',
    },
    gyCount: '{n} cards',
    menu: {
      tributeAtk: 'Invocação por Tributo (ATK)',
      tributeSet: 'Baixar por Tributo',
      asTribute: 'Escolher como tributo',
      undoTribute: 'Remover o tributo',
      normalAtk: 'Invocação Normal (ATK)',
      setMonster: 'Baixar (DEF virado para baixo)',
      activate: 'Ativar',
      set: 'Baixar',
      flipSummon: 'Invocação por Flip',
      changePosition: 'Mudar posição',
      attackDirect: 'Atacar diretamente',
      attackThis: 'Atacar {name}',
      attackFaceDown: 'Atacar o monstro virado para baixo',
      attackPick: 'Atacar um monstro',
      equip: 'Equipar',
      specialAtk: 'Invocação Especial (ATK)',
      specialDef: 'Invocação Especial (DEF)',
    },
    picker: {
      special: 'Invocar por Efeito qual monstro?',
      fusion: 'Invocar por Fusão qual monstro?',
      banishGy: 'Bana 1 ou 2 monstros do Cemitério do oponente',
      lastWill: 'Invocar do baralho? Cancelar deixa para depois neste turno.',
      fromCard: 'Efeito de {card}',
      flute: 'Invoque por Efeito até 2 Dragões da sua mão',
      egotist: 'Invoque por Invocação-Especial Lady Harpia ou Irmãs de Lady Harpia',
      fromHand: 'Mão',
      fromDeck: 'Deck',
      spy: 'Olhe 1 card na mão do oponente',
      peek: 'Você olhou estes cards',
      bigEye: 'Coloque-as de volta. A primeira que você escolher fica no topo do seu Deck.',
      peekReveal: 'The Stern Mystic revelou estes cards',
      peekSearch: 'Adicionada à mão',
      sangan: 'Adicione 1 monstro com 1500 ou menos de ATK do seu Deck',
      witch: 'Adicione 1 monstro com 1500 ou menos de DEF do seu Deck',
      thunderDragon: 'Adicione Dragão do Trovão do seu Deck',
      searchDeck: 'Adicione um card do seu Deck',
      yours: 'Seus',
      opp: 'Oponente',
      ownerHand: 'Se voltar para a mão, volta para a do dono.',
      gyEmpty: 'Vazio',
      confirm: 'Confirmar',
      close: 'Fechar',
      cancel: '✕ cancelar',
      selectExact: 'Escolha {n}',
      selectRange: 'Escolha {min}–{max}',
      chainOrder: 'Ordem da corrente. A primeira que você escolher resolve por último.',
      chainSearch: 'Busca no baralho',
      chainSword: 'Volta ao baralho',
      chainLife: 'Você perde Life Points',
      chainDiscard: 'O oponente descarta',
      chainDraw: 'Compre 1',
      chainDrawOpp: 'O oponente compra 2',
      doomedDiscard: 'Descarte 1 card',
      blastJuggler: 'Destrua 2 monstros com a face para cima e 1000 de ATK ou menos',
      coffin: 'Descarte de 1 a 3 monstros da sua mão',
      gySpell: 'Adicione 1 Magia do seu Cemitério à sua mão',
      gyTrap: 'Adicione 1 Armadilha do seu Cemitério à sua mão',
      magicJammer: 'Descarte 1 card para negar essa Magia',
      soulRelease: 'Bana até 5 cards de qualquer Cemitério',
      yadoBottom: 'Coloque cards no fundo do seu Deck. O último que você escolher fica no fundo.',
    },
    coin: {
      heads: 'Cara',
      tails: 'Coroa',
      close: 'Fechar',
    },
    prompt: {
      cancel: '✕ cancelar',
      pass: 'Não, passar',
      activate: 'Ativar {name}',
      offeringIgnite: 'Ultimate Offering: pagar 500 LP para Invocar de Modo Normal ou Baixar?',
      offeringPayBtn: 'Pagar 500 LP: {name}',
      offeringPayAction: 'Pagar 500 LP',
      trapOnSummon: 'Ativar uma Armadilha em resposta à invocação?',
      trapOnAttack: 'Ativar uma Armadilha em resposta ao ataque?',
      trapOnDamage: 'Ativar uma Armadilha antes do cálculo de dano?',
      chainTo: 'Encadear a {name}?',
      trapActivate: 'Ativar uma Armadilha?',
      discard: 'Acima do limite da mão — descarte {n} card(s): clique nos cards da sua mão',
      waitingDiscard: 'Esperando o oponente descartar…',
      flipTarget: '{name}: escolha um alvo — clique num card destacado',
      selectHighlighted: 'Escolha o card destacado',
      selectNamed: 'Escolha {name}',
      chainOrder: 'Ordene a corrente. A primeira resolve por último: {names}',
      chainOrderGo: 'Usar esta ordem',
      waitingChainOrder: 'Esperando o oponente ordenar a corrente…',
      waitingTarget: 'Esperando o oponente escolher um alvo…',
      coinCall: '{name}: escolha cara ou coroa',
      heads: 'Cara',
      tails: 'Coroa',
      waitingCoin: 'Esperando o oponente escolher cara ou coroa…',
      blastJuggler:
        '{name}: Oferecer como Tributo para destruir 2 monstros com a face para cima com 1000 de ATK ou menos?',
      mushroomGive: '{name}: pagar 500 LP para dar o controle dele ao oponente?',
      choiceYes: 'Sim',
      choiceNo: 'Não',
      waitingChoice: 'O oponente está decidindo…',
      waitingRespond: 'O oponente está decidindo…',
      viewingOwnGy: 'O oponente está vendo o próprio Cemitério…',
      viewingYourGy: 'O oponente está vendo o seu Cemitério…',
      viewingOwnGyNamed: '{name} está vendo o próprio Cemitério…',
      viewingOppGyNamed: '{name} está vendo o Cemitério de {other}…',
      waitingOffering: 'Esperando o oponente Invocar de Modo Normal ou Baixar…',
      offeringPay:
        'Ultimate Offering: pague 500 LP e depois Invoque de Modo Normal ou Baixe',
      offeringSummon:
        'Ultimate Offering: Invoque de Modo Normal ou Baixe da sua mão',
    },
    position: {
      summon: 'Invocar {name} em ATK ou Baixar?',
      select: 'Escolha a posição de {name}',
      attack: 'ATAQUE',
      defense: 'DEFESA',
      set: 'BAIXAR',
      faceDownDef: 'DEF virado para baixo',
    },
    error: {
      roomGone: 'Não foi possível retomar o duelo.',
      queueClosed: 'O ranqueado está em pausa. Tente de novo em alguns minutos.',
      eventClosed: 'Esta fila de evento está fechada.',
      eventDeck: 'Seu baralho não bate com as regras deste evento.',
      queueSwitched: 'Você entrou na outra fila.',
      tournamentBusy: 'Termine primeiro sua partida do torneio.',
      deck_banlist: 'Seu baralho não cumpre a banlist.',
      not_friends: 'Esse duelista não está na sua lista de amigos.',
      friend_offline: 'Esse amigo está offline.',
      friend_in_duel: 'Esse amigo já está em um duelo.',
      invalid_username: 'Esse nome não é válido.',
      waitingTrapResponse: 'Esperando uma resposta de armadilha',
      discardFirst: 'Você precisa descartar até o limite da mão primeiro',
      waitingFlipTarget: 'Esperando a escolha de alvo de um Efeito de Virar',
      waitingTarget: 'Esperando a escolha de um alvo',
      waitingOffering: 'Esperando Ultimate Offering',
      offeringSummonOrPass: 'Invoque de Modo Normal ou Baixe, ou passe',
      offeringSummonOwed: 'Ultimate Offering: Invoque de Modo Normal ou Baixe o monstro que você já pagou',
      notYourTurn: 'Não é o seu turno',
      notMainPhase: 'Não está numa Fase Principal',
      notBattlePhase: 'Não está na Fase de Batalha',
      notBattleStep: 'Não está no Battle Step',
      attackResolving: 'Um ataque ainda está resolvendo',
      notNow: 'Você não pode fazer isso agora',
      notNowWaiting: 'Você não pode fazer isso agora — esperando o oponente',
      skipEndOnly: 'Você só pode pular até a Fase Final',
      cannotSkipEnd: 'Não dá para pular para a Fase Final daqui',
      cardNotInHand: 'O card não está na mão',
      notMonster: 'Não é um monstro',
      fusionNoNormal: 'Monstros de Fusão não podem ser Invocados de Modo Normal',
      requiresTribute: 'Exige Invocação por Tributo',
      monsterZoneOccupied: 'Zona de monstro ocupada',
      invalidZone: 'Zona inválida',
      fusionNoTribute: 'Monstros de Fusão não podem ser Invocados por Tributo',
      noTributesNeeded: 'Não exige tributos',
      needsExactTributes: 'Precisa de exatamente {n} tributos',
      invalidTribute: 'Tributo inválido',
      noFreeMonsterZone: 'Não há zona de monstro livre',
      noNormalSummon: 'Este monstro não pode ser Invocado por Invocação-Normal nem Baixado',
      monsterNotFound: 'Monstro não encontrado',
      noPositionSummonTurn: 'Não pode mudar de posição no turno em que foi invocado',
      positionAlreadyChanged: 'A posição já mudou neste turno',
      monsterAlreadyAttacked: 'O monstro já atacou',
      dragonCaptureJar: 'Dragões estão travados em Posição de Defesa (Dragon Capture Jar)',
      alreadyFaceUp: 'Já está virado para cima',
      noFlipSetTurn: 'Não pode virar no turno em que foi Baixado',
      notSpellTrap: 'Não é uma magia/armadilha',
      noFreeSpellZone: 'Não há zona de magia/armadilha livre',
      notSpell: 'Não é uma magia',
      setSpellNotFound: 'Magia Baixada não encontrada',
      setTrapNotFound: 'Armadilha Baixada não encontrada',
      notTrap: 'Não é uma armadilha',
      trapSetDelay: 'Uma armadilha não pode ser ativada no turno em que foi Baixada',
      noDamageStep: 'Este card não pode ser ativado no Damage Step',
      cannotActivateNow: 'Este card não pode ser ativado agora',
      conditionsNotMet: 'As condições de ativação não foram cumpridas',
      noLegalTarget: 'Não há alvo válido para este card',
      selectValidTargets: 'Escolha alvos válidos para este card',
      selectValidTarget: 'Escolha um alvo válido para este card',
      noFlipPending: 'Não há escolha de flip pendente',
      notYourSelection: 'Não é a sua escolha',
      invalidTarget: 'Alvo inválido',
      noTargetPending: 'Não há escolha de alvo pendente',
      attackerNotFound: 'Atacante não encontrado',
      targetNotFound: 'Alvo não encontrado',
      cannotDirectAttack: 'O oponente controla monstros; não pode atacar diretamente',
      attackerFaceDown: 'O atacante está virado para baixo',
      attackerNotAttackPos: 'O atacante não está em Posição de Ataque',
      alreadyAttacked: 'Já atacou neste turno',
      noFirstTurnAttack: 'Não pode atacar no primeiro turno',
      swordsOfRevealingLight: 'Você não pode atacar (Swords of Revealing Light)',
      targetNotMonster: 'O alvo não é um monstro',
      noPendingResponse: 'Não há resposta pendente',
      notYourResponse: 'Não é a sua vez de responder',
      cardCannotActivateNow: 'Esse card não pode ser ativado agora',
      chainTooLong: 'A corrente está longa demais',
      cannotChainSlower: 'Não pode encadear um efeito mais lento',
      spellSpeed1NoChain: 'Spell Speed 1 não pode ser encadeado',
      noDiscardOwed: 'Você não deve um descarte',
      cardNotYourHand: 'Esse card não está na sua mão',
      normalSummonUsed: 'A Invocação Normal já foi usada neste turno',
      offeringPhase: 'Ultimate Offering: sua Fase Principal ou a Fase de Batalha do oponente',
      notEnoughLp: 'Pontos de Vida insuficientes',
      noOfferingMonster: 'Não há um monstro que você possa Invocar de Modo Normal ou por Tributo',
      matchNotFound: 'Partida não encontrada',
      notInMatch: 'Você não está nesta partida',
      sessionMoved: 'Este duelo continuou no seu outro aparelho',
      invalidAction: 'Ação inválida',
      spectateDenied: 'Esse duelo não pode ser assistido',
      internalError: 'Erro interno',
    },
    msg: {
      offeringPassed: '{name}: passou.',
      offeringAgain: '{name}: você pode Invocar de Modo Normal ou Baixar de novo.',
      unsupportedAction: 'Ação ainda não suportada pelo motor',
      discardDown: 'Descarte {n} card(s) até {limit}.',
      flipActivated: '{name}: Efeito de Virar ativado!',
      flipNoTarget: '{name}: Efeito de Virar — sem alvo válido',
      attackCancelled: 'O ataque foi cancelado: {reason}.',
      attackCancelAttacker: 'o atacante não pode mais atacar',
      attackCancelTarget: 'o alvo saiu do campo',
      attackCancelOpp: 'o oponente agora controla um monstro',
      wabokuDamage: '{name}: o dano de batalha vira 0.',
      kuribohDamage: '{name}: este ataque causa 0 de dano de batalha.',
      wabokuAttacker: '{name}: o monstro atacante não é destruído em batalha neste turno.',
      wabokuDefender: '{name}: o monstro defensor não é destruído em batalha neste turno.',
      noResponse: 'Sem resposta.',
      fizzled: '{name} falhou (os alvos já não são legais).',
      egotistNoLady: '{name}: não há uma Lady Harpia virada para cima no campo.',
      egotistNoZone: '{name}: não há zona de monstro livre.',
      egotistNoMonster:
        '{name}: não há Lady Harpia nem Irmãs de Lady Harpia na sua mão ou no Deck.',
      noLegalTarget: '{name}: sem alvo válido.',
      reverseTrap: '{name}: modificadores de ATK e DEF ficam invertidos até a Fase Final.',
      bigEye: '{name}: {n} card(s) voltaram para o topo do Deck.',
      shieldSword: '{name}: o ATK e a DEF originais são trocados até o final deste turno.',
      returnedToExtra: '{name} voltou ao Deck Adicional.',
      revealDestroyed: '{name} era um {kind} — destruído.',
      revealSetAgain: '{name} era um {kind} — Baixado de novo (não destruído).',
      kindTrap: 'Armadilha',
      kindSpell: 'Magia',
      barrelHit: '{name}: {heads} caras. Esse monstro é destruído.',
      barrelMiss: '{name}: {heads} caras. Nada é destruído.',
      coinCall: '{name}: escolha cara ou coroa.',
    },
    toast: {
      flipFirst: 'Escolha um alvo para o Efeito de Virar primeiro',
      mainPhaseOnly: 'Você só pode jogar da mão durante a sua Fase Principal',
      offeringPayFirst: 'Pague 500 LP primeiro',
      notEnoughTribute: 'Não há monstros suficientes para tributo',
      noMonsterZone: 'Não há zona de monstro livre',
      noSpellZone: 'Não há zona de magia/armadilha livre',
      notEnoughField: 'Não há monstros suficientes no campo para este card',
      noValidTarget: 'Não há alvo válido para este card',
      equipNeedsRace: 'Equipe-a em um monstro do tipo {race} com a face para cima',
      equipNeedsAttr: 'Equipe-a em um monstro de {attr} com a face para cima',
      equipNotRace: 'Você não pode equipá-la em um monstro do tipo {race}',
      equipNeedsMonster: 'Equipe-a em um monstro com a face para cima',
      selectTarget: 'Escolha um alvo',
      fissureTie: 'Fissure: o ATK mais baixo empatou. Escolha qual monstro destruir.',
      cancelled: 'Ativação cancelada',
      highlighted: 'Escolha um dos cards destacados',
      mustChooseTarget: 'Este card já está ativado — escolha um alvo',
      sistersEgotist:
        'Irmãs de Lady Harpia só é Invocada por Invocação-Especial com Egotista Elegante, da mão ou do Deck. Toque nela nessa lista e escolha ataque ou defesa.',
      invalidTarget: 'Esse card não é um alvo válido para este card',
      selectTribute: 'Escolha {need} monstro(s) para tributo ({selected}/{need})',
      clickOwnTribute: 'Clique nos seus monstros para tributo',
      soulExchangeNoZone:
        'Soul Exchange não libera uma zona de monstro. Tribute um dos seus, ou deixe uma zona vazia.',
      invalidStep: 'Esse monstro não é uma escolha válida nesta etapa',
      selectAttack: 'Escolha um monstro inimigo para atacar',
      replay: 'Replay — escolha um novo ataque ou passe',
      skipBattle: 'Você não pode entrar na Fase de Batalha neste turno',
      escCancel: ' — Esc para cancelar',
      destroyYours: 'Escolha 2 dos seus monstros para destruir',
      destroyOpp: 'Escolha o monstro do oponente para destruir',
      cocoonNeeds: 'Equipe-a em um Petit Moth com a face para cima',
      cocoonPick: 'Escolha um Petit Moth com a face para cima',
      gateNeeds: 'Você precisa de Sanga of the Thunder, Kazejin e Suijin no seu campo',
      gateTributes: 'Tribute Sanga of the Thunder, Kazejin e Suijin',
      larvaeNeeds: 'Petit Moth com Cocoon of Evolution, no seu turno 2',
      greatNeeds: 'Petit Moth com Cocoon of Evolution, no seu turno 4',
    },
  },
  ops: {
    kicker: 'Interno',
    title: 'Ops',
    lead: 'Contas, a fila, duelos ao vivo, partidas ranqueadas, cards, cópias da coleção, caixa de correio, chat e a enquete da coleção.',
    home: 'Início',
    keyLabel: 'Chave de admin',
    keyError: 'Essa chave não abre esta página.',
    unlock: 'Desbloquear',
    loadError: 'Não foi possível carregar esta vista.',
    empty: 'Nada aqui ainda.',
    search: 'Buscar',
    searchUsers: 'Nome de usuário ou e-mail',
    filterActivity: 'Atividade',
    filterAll: 'Todos',
    filterDay: 'Ativos hoje',
    filterWeek: 'Ativos esta semana',
    filterNew: 'Novos esta semana',
    filterIdle: 'Inativos (7 dias)',
    filterRole: 'Tipo',
    filterAdmins: 'Admins',
    filterPlayers: 'Jogadores',
    filterSort: 'Ordenar',
    sortNewest: 'Mais novos',
    sortSeen: 'Visto por último',
    sortLevel: 'Nível',
    sortCoins: 'Moedas',
    sortDuels: 'Duelos',
    sortCollection: 'Coleção',
    sortRanked: 'Ranqueadas',
    adminBadge: 'Admin',
    portrait: {
      title: 'Retrato exclusivo',
      lead: 'Só a sua conta pode usá-lo. Os outros duelistas veem isso nos duelos e no chat.',
      upload: 'Enviar imagem',
      uploading: 'Enviando…',
      uploadLead:
        'Escolha uma imagem neste computador. Ao enviar, ela vira o seu retrato.',
      wear: 'Usar este retrato',
      wearing: 'Você está usando',
      error: 'Não foi possível salvar o retrato.',
      uploadError: 'Não foi possível salvar essa imagem.',
      badType: 'Esse arquivo não é uma imagem que possa ser usada.',
    },
    userCount: '{n} contas',
    deleteUser: 'Apagar conta',
    deleteLead: 'Apaga a conta, os baralhos, o álbum e o histórico. Isto não pode ser desfeito.',
    deleteAdminWarn: 'Esta conta também é admin.',
    deleteType: 'Digite {name} para confirmar',
    deleteConfirm: 'Apagar',
    deleteCancel: 'Cancelar',
    deleteError: 'Não foi possível apagar a conta.',
    deleteMismatch: 'O nome de usuário não confere.',
    deleteSelf: 'Você não pode apagar a sua própria conta.',
    masterPacks: 'Master Packs',
    rewardTitle: 'Enviar recompensa',
    rewardLead:
      'O jogador recebe esta mensagem no correio e resgata lá as moedas ou os Master Packs.',
    rewardMessage: 'Mensagem',
    rewardPlaceholder: 'Escreva um recado para este jogador',
    rewardDoneMailbox: 'Enviado para o correio.',
    rewardKind: 'Recompensa',
    rewardCoins: 'Moedas',
    rewardPacks: 'Master Packs',
    rewardQty: 'Quantidade',
    rewardSend: 'Enviar',
    rewardSending: 'Enviando…',
    rewardError: 'Não foi possível enviar a recompensa.',
    rewardDoneCoins: 'Enviado. Esta conta agora tem {n} moedas.',
    rewardDonePacks: 'Enviado. Esta conta agora tem {n} Master Packs.',
    backList: 'Voltar à lista',
    prev: 'Anterior',
    next: 'Próximo',
    tabs: {
      overview: 'Visão geral',
      logs: 'Registros',
      live: 'Ao vivo',
      queue: 'Fila',
      users: 'Usuários',
      duels: 'Duelos',
      cards: 'Cards',
      decks: 'Baralhos',
      pulls: 'Coleção',
      ranked: 'Ranqueado',
      chat: 'Chat',
      feedback: 'Caixa de correio',
      poll: 'Enquete',
      tourneys: 'Torneios',
      reset: 'Reset da expansão',
    },
    maintenance: {
      title: 'Manutenção',
      lead: 'Fecha o site agora. Não apaga contas, cartas nem roda o reset.',
      on: 'Entrar em manutenção',
      confirmOn: 'Fechar o site',
      confirmOnHint: 'Todos veem o aviso e os duelos ao vivo se desconectam. Esta página de admin continua aberta.',
      off: 'Abrir o site',
      confirmOff: 'Abrir o site',
      confirmOffHint: 'O aviso some e o ranqueado volta a aceitar jogadores.',
      stateFull: 'O site está em manutenção.',
      stateClosed: 'A entrada está fechada. A manutenção completa ainda não.',
      stateOff: 'O site está aberto.',
      errors: {
        failed: 'Não foi possível mudar a manutenção.',
        reset_in_progress: 'Há um reset em andamento. O site abre quando essa lista terminar.',
      },
    },
    eventQueue: {
      title: 'Fila de evento semanal',
      lead: 'Um modo por vez, sete dias. Os duelos terminados pagam 7 moedas na vitória e 5 na derrota ou empate, igual ao ranqueado. Quem ganhar um duelo recebe uma faixa só de Master Packs, contada entre quem ganhou: 20 o top 1%, 15 o resto do top 10%, 8 o resto do top 25%, 4 o resto do top 50% e 2 o resto. Ranqueado e casual não mudam.',
      none: 'Nenhum evento está ativo.',
      live: '{mode} está ativo até {time}.',
      mode: 'Modo',
      start: 'Começar 7 dias',
      startConfirm: 'Começar',
      startHint: 'Abre esta fila por uma semana. Só pode haver um evento ativo.',
      end: 'Encerrar agora',
      endConfirm: 'Encerrar e pagar',
      endHint: 'Fecha a fila e envia Master Packs a quem tiver uma vitória.',
      place: '#',
      player: 'Jogador',
      wins: 'V–D',
      notices: {
        started: 'A fila de evento está ativa.',
        ended: 'O evento fechou e os prêmios foram enviados.',
        none: 'Não havia um evento ativo.',
        event_live: 'Já há um evento ativo.',
        failed: 'Não foi possível alterar a fila de evento.',
      },
    },
    tournament: {
      title: 'Torneios',
      lead: 'Os torneios automáticos usam as vagas, o início e o intervalo abaixo. A pausa para o horário. Iniciar agora não espera esse turno. Uma inscrição já aberta conserva suas vagas e seu horário.',
      paused: 'Os torneios automáticos estão em pausa.',
      running: 'Os torneios automáticos saem a cada {n} minutos.',
      phaseNone: 'Não há um torneio aberto.',
      phaseRegistration: 'Inscrição aberta. {n} inscritos de {max}. Começa {time}.',
      seats: 'Vagas',
      startWhenFull: 'Começar ao lotar',
      interval: 'Minutos entre torneios',
      save: 'Salvar',
      openKeeps: 'A inscrição aberta conserva {n} vagas.',
      phaseLive: 'Há um torneio em andamento.',
      pause: 'Pausar automáticos',
      pauseConfirm: 'Pausar',
      pauseHint: 'Nenhum torneio automático abre nem começa. O que já está em jogo continua.',
      resume: 'Retomar automáticos',
      resumeConfirm: 'Retomar',
      resumeHint: 'O horário volta. Se havia uma inscrição cujo início já passou, ela começa na hora.',
      start: 'Abrir torneio agora',
      startConfirm: 'Abrir inscrição',
      startHint: 'A inscrição abre agora. Começa em 30 minutos, ou antes se você iniciar a chave. Com a pausa ativa, não começa sozinho.',
      begin: 'Iniciar a chave',
      beginConfirm: 'Iniciar agora',
      beginHint: 'Começa com quem já está inscrito. São necessários 4. Com menos, a inscrição continua aberta.',
      notices: {
        opened: 'A inscrição está aberta.',
        live: 'A chave começou.',
        need_players: 'São necessários 4 inscritos. A inscrição continua aberta.',
        live_busy: 'Já há um torneio em andamento.',
        paused: 'Os torneios automáticos ficaram em pausa.',
        resumed: 'Os torneios automáticos voltaram ao horário.',
        saved: 'Salvo. O próximo torneio automático usa estes valores.',
        failed: 'Não foi possível mudar os torneios.',
      },
    },
    tourneyHistory: {
      lead: 'Os torneios deste servidor, inclusive os que já terminaram. Se o duelo foi jogado, a chave tem Ver replay. Uma folga sem duelo não tem.',
      live: 'Em andamento',
    },
    reset: {
      title: 'Reset da expansão',
      start: 'Começar reset',
      confirm: 'Confirmar reset',
      confirmHint: 'Isso zera cópias, moedas, nível, baralhos, pacotes e a banlist. O álbum e os cosméticos ficam.',
      retry: 'Tentar de novo',
      running: 'Em andamento',
      done: 'Reset terminado',
      waiting: '{n} duelos em andamento',
      empty: 'Não há um reset pendente.',
      errors: {
        expansion_not_ready: 'Esta expansão ainda não está no servidor.',
        migrations_behind: 'Faltam migrações no banco.',
        devtools_open: 'As ferramentas de desenvolvimento não estão fechadas.',
        step_out_of_order: 'Esse passo não é o próximo.',
        no_reset: 'Não há um reset pendente.',
        step_failed: 'O passo falhou. Tente de novo a partir daqui.',
      },
      steps: {
        'expansion-ready': 'Expansão no servidor',
        migrations: 'Migrações em dia',
        devtools: 'Ferramentas de desenvolvimento fechadas',
        'close-entry': 'Entrada fechada',
        'wait-duels': 'Duelos em andamento terminados',
        'maintenance-full': 'Manutenção completa',
        backup: 'Backup salvo',
        'close-season': 'Temporada fechada',
        'save-album': 'Álbum salvo',
        'wipe-copies': 'Cópias em zero',
        'wipe-packs': 'Pacotes reiniciados',
        'wipe-coins': 'Moedas em zero',
        'wipe-xp': 'Nível em zero',
        'wipe-decks': 'Baralhos apagados',
        'reset-league': 'Liga em colocação',
        'restore-promos': 'Promos devolvidas',
        'clear-banlist': 'Banlist vazia',
        'grant-rewards': 'Prêmios de fechamento entregues',
        'open-season': 'Temporada nova aberta',
        'mail-special': 'Pacote especial enviado',
        'mark-done': 'Reset marcado',
        'maintenance-off': 'Site aberto',
      },
    },
    cardsLead:
      'Cards que os duelistas levam ao começar um duelo, nesta temporada. A barra de cima é o uso diante do card mais visto. A de baixo é a taxa de vitória em duelos já terminados.',
    cardsDecks: '{n} baralhos',
    cardsUsage: 'Uso {n}%',
    cardsWin: 'Vitórias {n}',
    cardsMinUsage: 'Uso mínimo',
    cardsMinWin: 'Vitórias mínimas',
    cardsAny: 'Qualquer',
    cardsMatch: '{n} cards',
    cardsBanlist: 'Banlist',
    cardsBanlist1: 'Limited — máximo 1',
    cardsBanlist2: 'Semi-Limited — máximo 2',
    cardsBanlistOpen: 'Sem limite',
    cardsBanlistNot1: 'Não limited a 1',
    cardsCap: 'máx. {n}',
    cardsAvg: '{n} cópias por baralho',
    decksLead:
      'Duelos terminados nesta temporada, agrupados quando os baralhos principais se parecem. O Deck Adicional fica de fora. As imagens são a lista principal mais jogada do grupo. Uma carta em pelo menos 40% desses duelos sai do nome. Na horizontal, o quanto o grupo é jogado. Na vertical, o win rate. Em cima à direita é o que mais aparece e mais ganha.',
    decksMain: 'Baralho principal',
    decksSeason: 'Temporada',
    decksSeasonOpen: '{name} · agora',
    deckSeason: {
      'set-mrd': 'Metal Raiders',
      'set-mrl': 'Magic Ruler',
    },
    decksBracket: 'Liga',
    decksAllLeagues: 'Todas as ligas',
    decksTop: 'Champion e King',
    decksLoading: 'Carregando baralhos…',
    decksEmpty: 'Ainda não há listas nesta temporada.',
    decksStaples: 'Base',
    decksPlay: 'Jogado em {n}% dos duelos',
    decksWin: 'Win rate {n}',
    decksRecord: '{wins} vitórias · {losses} derrotas · {draws} empates',
    decksDuels: '{n} duelos',
    decksTrend: 'Últimos 7 dias {recent}% · os 7 anteriores {prev}%',
    decksTrendRecent: 'Últimos 7 dias {recent}%',
    decksHidden: '{n} grupos com menos de 5 duelos não aparecem.',
    decksChart: 'Uso e win rate',
    decksPlayAxis: 'Uso',
    decksWinAxis: 'Win rate',
    pullsLead:
      'Cópias que cada jogador tem agora. O número é quantos a têm. A barra compara esse número com os {players} jogadores que têm álbum. Toque um card para ver quem tem 2 ou 3 cópias.',
    pullsLoading: 'Carregando a coleção…',
    pullsSummary:
      '{cards} cards · {none} sem dono · {two} com 2 cópias · {playset} com 3 cópias',
    pullsSortFew: 'Menos jogadores',
    pullsSortMany: 'Mais jogadores',
    pullsSortCatalog: 'Ordem do álbum',
    pullsAll: 'Todos',
    pullsTwo: 'Com 2',
    pullsThree: 'Com 3',
    pullsNone: 'Ninguém',
    pullsLegendThree: 'Alguém tem 3',
    pullsLegendTwo: 'Alguém tem 2',
    pullsLegendNone: 'Ninguém tem',
    pullsOwners: '{n} de {players}',
    pullsCopies: '{n} cópias',
    pullsNobody: 'Ninguém tem 2 ou mais cópias.',
    pullsPick: 'Toque um card para ver os nomes.',
    pullsTile: '{name}. {n} jogadores, {two} com 2 cópias, {three} com 3.',
    pollLead:
      'Votos sobre cards proibidos agora, ou por enquanto só cards limitados. Um proibido não pode ser jogado: 0 cópias.',
    pollForbidden: 'Cards proibidos',
    pollLimited: 'Só limitados',
    pollNone: 'Sem voto',
    pollTally: '{forbidden} proibidos · {limited} só limitados',
    pollEmpty: 'Ainda não há votos.',
    bugReal: 'Era real',
    bugDismiss: 'Não era um bug',
    bugPending: 'Pendente',
    bugPaid: 'Pacote pago',
    bugDismissed: 'Descartado',
    bugReviewError: 'Não foi possível salvar a revisão.',
    bugReply: 'Responder',
    bugReplied: 'Respondido',
    bugReplyTitle: 'Responder a {name}',
    bugReplyLead:
      'Fecha este reporte. O jogador recebe a mensagem no correio e resgata a recompensa lá.',
    bugReplyMessage: 'Mensagem',
    bugReplyCoins: 'Moedas',
    bugReplyPacks: 'Master Packs',
    bugReplyHint: 'Use 0 se não quiser essa recompensa.',
    bugReplySend: 'Enviar e fechar',
    bugReplySending: 'Enviando…',
    bugReplyCancel: 'Cancelar',
    bugReplyError: 'Não foi possível enviar a resposta.',
    devices: 'Dispositivos',
    deviceNone: 'Ainda não há um dispositivo salvo.',
    deviceUnknown: 'Desconhecido',
    deviceInstalled: 'App instalado',
    deviceBrowser: 'Navegador',
    deviceFullscreen: 'Tela cheia',
    deviceTouch: 'Toque',
    devicePointer: 'Ponteiro',
    deviceLock: 'Bloqueio horizontal',
    deviceNoLock: 'Sem bloqueio horizontal',
    liveLead:
      'Duelos em andamento. Esta lista se atualiza sozinha. Duelos PvP podem ser abertos no tabuleiro. Duelos contra a IA podem ser encerrados aqui, e se encerram sozinhos ao completar uma hora.',
    watch: 'Assistir',
    liveFilter: 'Mostrar',
    liveAll: 'Todos',
    liveAi: 'Contra a IA',
    livePvp: 'PvP',
    modeAi: 'Contra a IA',
    modeCasual: 'Casual',
    modeRanked: 'Ranqueado',
    modeEvent: 'Evento',
    liveHand: 'mão',
    liveDeck: 'baralho',
    offline: 'desconectado',
    liveEmpty: 'Ninguém está num duelo agora.',
    queueLead:
      'Contas esperando a Partida rápida. Elas se emparelham quando a diferença de rating cabe na janela de quem espera há menos tempo. Começa em ±{start}, vai a ±{mid} após {midWait} s e abre após {openWait} s. Com menos de {pool} contas ranqueadas nesta semana, a janela fica aberta. Esta lista se atualiza sozinha.',
    queueEmpty: 'Ninguém está na fila.',
    queueGate: 'Partida rápida',
    queueGateOn: 'Aberta. Os duelistas podem entrar na fila.',
    queueGateOff:
      'Fechada. Ninguém novo pode começar um duelo ranqueado. Quem já espera volta ao início. Os duelos em andamento continuam. A fila abre de novo quando este servidor reinicia.',
    queueGateError: 'Não foi possível mudar a fila.',
    queueCount: '{n} na fila',
    queuePairReady: 'Há um par possível. O servidor confere a cada 5 segundos.',
    queuePairBlocked: '{n} na fila, e ninguém está perto o bastante ainda.',
    queueSmallPool: 'Poucas contas ranqueadas nesta semana ({n}). A janela fica aberta.',
    queueNormalPool: 'Contas ranqueadas nesta semana: {n}.',
    queueRating: 'Rating {rating} · RD {rd}',
    queuePlacement: 'Colocação · faltam {n}',
    queueLeagueLp: '{name} · {lp} LP',
    queueWindow: 'Janela própria: ±{n}',
    queueWindowOpen: 'Janela própria: aberta',
    queueAlone: 'Esperando outra conta.',
    queueNearestYes: 'Pode emparelhar com {name} (diferença {diff}).',
    queueNearestNo: 'O mais próximo é {name}, a {diff} de rating. Ainda faltam {short} para entrar na janela.',
    queueShowDeck: 'Ver baralho',
    queueHideDeck: 'Ocultar baralho',
    queueMat: 'Playmat: {name}',
    queueAccount: 'Ver conta',
    liveEnd: 'Encerrar duelo',
    liveEndConfirm: 'Encerrar',
    liveEndCancel: 'Cancelar',
    usersTotal: 'Contas',
    activeDay: 'Ativos hoje',
    activeWeek: 'Ativos esta semana',
    newWeek: 'Novos esta semana',
    dropoutTitle: 'Taxa de desistência',
    dropoutLead: 'Contas com mais de 7 dias. Não voltaram: um único login.',
    dropoutGauge: 'Desistência {n} por cento',
    dropoutCreated: 'Criadas',
    dropoutReturned: 'Voltaram alguma vez',
    dropoutGone: 'Não voltaram',
    dropoutWeeks: 'Por semana de registro',
    dropoutWeeksLead: 'Segundo login em até 7 dias. Só semanas já fechadas.',
    dropoutBack: 'Voltaram',
    dropoutNever: 'Não voltaram',
    dropoutCurve: 'Curva de retorno',
    dropoutCurveLead:
      'Percentual com um segundo login até esse dia. Contas dos últimos 120 dias que já completaram o dia.',
    dropoutDay: 'Dia {n}',
    packsWeek: 'Pacotes abertos (7d)',
    coinsWeek: 'Moedas criadas / gastas (7d)',
    chatWeek: 'Mensagens do chat (7d)',
    logsLead: 'Cada lista fica na própria aba. O resumo só mostra os totais.',
    logs: {
      stall: 'Travas',
      fault: 'Falhas',
      summon: 'Invocação',
      probe: 'Casos',
      entry: 'Entrada',
      pvp: 'PvP',
    },
    probeLog: 'Rejeições, conexões e cartas sem desenho (7d)',
    probeLead:
      'Uma rejeição é um clique que o servidor não aceitou. A conexão é o socket. Sem desenho é uma carta que o duelo tinha e o tabuleiro não mostrou.',
    probe: {
      action_rejected: 'Rejeição',
      duel_link: 'Conexão',
      board_gap: 'Sem desenho',
      duel_hidden: 'Aba oculta',
    },
    entryLead:
      'A primeira vez que um jogador abre a sala do torneio. O aviso é o diálogo na tela. A notificação é o aviso do sistema. A chave é o botão no chaveamento. Próxima rodada é quando o jogo passa sozinho.',
    entryHow: 'Como entrou',
    entryVia: {
      dialog: 'Aviso',
      notice: 'Notificação',
      bracket: 'Chave',
      advance: 'Próxima rodada',
      unknown: 'Sem dado',
    },
    pvpLogLead:
      'Jogadas de duelos entre duas pessoas, com as duas mãos iniciais. Duelos anteriores não aparecem.',
    pvpLogHands: 'Mãos iniciais',
    pvpLogFirst: '{name} começa',
    pvpLogTrimmed: 'As primeiras jogadas não couberam. Aqui está o final.',
    pvpLogOpen: 'Ver jogadas',
    pvpLogClose: 'Ocultar jogadas',
    pvpLogLoading: 'Carregando jogadas…',
    pvpLogSet: '{name} baixou {card}',
    pvpLogGy: '{card} foi para o Cemitério',
    pvpLogPeek: '{name} olhou {cards}',
    pvpLogPeekReveal: '{name} revelou {cards}',
    pvpLogAsk: '{name} precisa escolher para {card}: {target} ({where})',
    pvpLogAskLeft:
      '{name} ainda precisava escolher um alvo de {card} quando o duelo acabou ({n})',
    pvpAsk: {
      set: 'baixado',
      def: 'Defesa',
      atk: 'Ataque',
      up: 'virado para cima',
      gy: 'Cemitério',
      hand: 'mão',
      deck: 'Baralho',
      ban: 'removido de jogo',
      extra: 'Deck Adicional',
      zone: '{where}, zona {n}',
    },
    summonLocksWeek: 'Invocação travada (7d)',
    summonLockLog: 'Invocações travadas recentes',
    summonLock: {
      throw: 'A animação falhou',
      watchdog: 'O seguro soltou o tabuleiro',
      resync: 'Pediu o estado de novo',
    },
    stallsWeek: 'Travas da Fase de Batalha (7d)',
    stallReason: 'Causa',
    stall: {
      playback: 'Animação travada',
      substep: 'Etapa de batalha travada',
      prompt: 'Aviso ausente',
      ai: 'IA parada',
    },
    stallLog: 'Travas recentes',
    stallTurn: 'Turno',
    stallSeat: 'Na vez',
    stallAnswer: 'Precisa responder',
    stallMe: 'este jogador',
    stallOpp: 'o oponente',
    stallPrompt: 'Janela',
    stallAttack: 'Ataque',
    stallChain: 'Corrente',
    stallField: 'Monstros',
    stallBack: 'Magias e armadilhas',
    stallRecent: 'Últimos eventos',
    faultsWeek: 'Trap Hole, Ultimate Offering e Last Will (7d)',
    faultLog: 'Falhas recentes dessas cartas',
    faultCard: 'Carta',
    faultCardName: {
      trap_hole: 'Trap Hole',
      offering: 'Ultimate Offering',
      last_will: 'Last Will',
    },
    fault: {
      target: 'Pediu um alvo',
      prompt: 'Aviso ausente',
      offering_hand: 'A mão não deixou invocar',
      wrong_turn: 'Disparou fora do turno',
    },
    duelsWeek: 'Duelos (7d)',
    aiWeek: 'Contra a IA (7d)',
    mode: 'Modo',
    count: 'Contagem',
    wins: 'Vitórias',
    difficulty: 'Dificuldade',
    username: 'Nome de usuário',
    email: 'E-mail',
    lastSeen: 'Visto por último',
    level: 'Nível',
    coins: 'Moedas',
    duelsCol: 'Duelos',
    playTime: 'Tempo jogado',
    playMinutes: '{n} min',
    playHours: '{n} h',
    playHoursMinutes: '{h} h {m} min',
    collectionCol: 'Cartas',
    decksCol: 'Baralhos',
    uniqueShort: '{n} únicas',
    created: 'Criado',
    albumCopies: 'Cartas no álbum',
    album: 'Cartas únicas',
    decks: 'Baralhos',
    deckActive: 'Em uso',
    deckMain: 'Baralho principal',
    deckExtra: 'Baralho extra',
    recentDuels: 'Duelos recentes',
    recentPackBuys: 'Compras de pacotes',
    packBuyItem: 'Pacote',
    packBuyOk: 'Comprado',
    recentChat: 'Chat recente',
    settingsSaved: 'Salvo {when}',
    prefOn: 'Sim',
    prefOff: 'Não',
    channel: 'Canal',
    allChats: 'Todos os chats',
    chatGlobal: 'Global',
    chatRoom: 'Duelo',
    chatSearch: 'Nome de usuário ou mensagem',
    when: 'Quando',
    result: 'Resultado',
    source: 'Origem',
    allModes: 'Todos os modos',
    rankedLead:
      'Cada partida rápida fica registrada com os pontos de liga dos dois jogadores. Partidas anteriores a este registro só mostram a mudança de pontos.',
    rankedSearch: 'Nome de usuário',
    rankedCount: '{n} partidas',
    rankedPlayer: 'Jogador',
    rankedOpponent: 'Oponente',
    rankedPoints: 'Pontos',
    rankedAfter: 'Depois',
    rankedWinner: 'Venceu',
    rankedHistory: 'Ranqueadas',
    rankedPlayed: 'Partidas',
    rankedWins: 'Vitórias',
    rankedLosses: 'Derrotas',
    rankedDraws: 'Empates',
    rankedGained: 'Pontos ganhos',
    rankedLost: 'Pontos perdidos',
    rankedWin: 'Vitória',
    rankedLoss: 'Derrota',
    rankedDraw: 'Empate',
    rankedPlacement: 'Colocação · faltam {n}',
    rankedPlacementDone: 'Colocação terminada',
    rankedNone: 'Sem rank',
    rankedStanding: 'Rank',
    rankedCol: 'Ranqueadas',
  },
}
